/* eslint-disable react/no-unescaped-entities */

import { Fragment } from 'react';

import { capitalize } from 'lodash';
import { Dictionary, DICTIONARY_LINKS } from '../types';

export const dictionary: Dictionary = {
  certification: 'Certification',
  since: 'since',
  notAvailableAnymore: 'No longer available',
  workingHours: 'Working Hours',
  commuteDistance: 'Travel distance',
  relocation: 'Relocation',
  salary: 'Salary',
  preferredJobs: 'Preferred Jobs',
  total: 'Total',
  unableToRefresh: 'Unable to Refresh',
  current: 'Current',
  past: 'Past',
  today: 'Today',
  noDataAvailable: 'No data available',
  cvAvailable: 'CV Available',
  hours: 'Hours',
  pasteJobDescription: 'Paste here your job description',

  login: 'Log In',
  rememberMe: 'Remember Me',
  logout: 'Log Out',
  registerAccount: 'Create an Account',
  newCompany: 'New Company',
  required: 'Required',
  notRequired: 'Not required',
  questionnaireMustHave: 'Must',
  questionnaireNiceToHave: 'Nice',
  questionnaireMustHaveTooltip: (
    <>
      Defines an essential requirement for the role.
      <br />
      Other questions provide additional context.
    </>
  ),
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  forgotPassword: 'Forgot Password?',
  forgotYourPassword: 'Forgot your Password?',
  forgotPasswordDescription:
    "A password reset link will be sent to your email to reset your password. If you don't get an email within a few minutes, please re-try.",
  resetPassword: 'Reset Password',
  multiFactorAuth: 'Verification token',
  enterMultiFactorAuthCode: 'Please, provide the verification token code sent on your email',
  resetPasswordMailSentDescription: 'A password reset link sent to your e-mail address. Please check your emails.',
  mailSent: 'Mail Sent',
  pleaseEnterYourNewPassword: 'Please Enter Your New Password',
  preferences: 'Preferences',
  email: 'Email',
  emailNotifications: 'Email notifications',
  sendEmail: 'Send Email',
  username: 'Username',
  userName: 'User name',
  password: 'Password',
  passwordRepeat: 'Password (Repeat)',
  overview: 'Overview',
  new: 'New',
  viewAll: 'View All',
  statistics: 'Statistics',
  comingSoon: 'Coming Soon',
  administration: 'Administration',
  connections: 'Connections',
  availableCredits: (left, total, isPayPerMatch = false) => (
    <Fragment>
      {isPayPerMatch ? 'Matches' : 'Leads'} <b>{left}</b>/{total} available
    </Fragment>
  ),
  cv: 'CV',
  profile: 'Profile',
  emailAddress: 'Email address',
  emailAddressForTeams: 'Team email address',
  phoneNumber: 'Phone number',
  nickname: 'Nickname',
  companyName: 'Company name',
  companiesWorkedAt: 'Companies worked at',
  companiesWorkedAtPlaceholder: 'e.g. Rabobank',
  companySize: 'Company size',
  companyType: 'Company type',
  selectCountry: 'Select a country',
  selectATS: 'Select your ATS',
  whatATSAreYouUsing: 'What ATS are you using?',
  howDidYouHearAboutUs: 'How did you hear about us?',
  pleaseExplain: 'Please explain...',
  submit: 'Submit',
  save: 'Save',
  next: 'Next',
  previous: 'Previous',
  back: 'Back',
  cancel: 'Cancel',
  saveChanges: 'Save Changes',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  repeatNewPassword: 'New Password (Repeat)',
  chooseFile: 'Choose File',
  noFileChosen: 'No File Chosen',
  roles: 'Roles',
  users: 'Users',
  user: 'User',
  ats: 'ATS',

  addedToAts: 'added to ATS',
  jobBoards: 'Job Boards',
  useRolesToGroupPermissions: 'Use Roles to Group Permissions',
  manageUsersAndPermissions: 'Manage Users and Permissions',
  recruitmentAgency: 'Recruitment Agency',
  corporate: 'Corporate',
  freelancer: 'Freelancer',
  selectInHouseRecruiters: 'Select the number of inhouse recruiters',
  cantBeLessThanZeroRecruiters: "You can't have less than 0 recruiters",
  thisFieldIsRequired: 'This field is required.',
  validationRequiredEmail: 'Please enter a valid email address.',
  useYourWorkEmailAddress: 'Please use a work e-mail.',
  validationPasswordConfirm: 'Please enter the same value again.',
  editCriteriaForMoreResults: 'Edit criteria for more results',
  newResultsInHours: (hours) => <Fragment>New results in {hours} hours</Fragment>,
  newResultsOnMonday: 'New results on Monday',
  thereAreNewResults: (newResults) => `${newResults} new`,
  untitledSearch: 'Untitled search',
  newSearch: 'New Search',
  searches: 'Searches',
  candidates: 'Candidates',
  teamview: 'Teamview',
  teamView: 'Team view',
  status: 'Status',
  lastAdded: 'Last Added',
  coWorker: 'Co-Worker',
  search: 'Search',
  sortBy: 'Sort by',
  sortedBy: 'Sorted by',
  mySearches: 'My Searches',
  teamSearches: 'Team Searches',
  allSearches: 'All Searches',
  allShortlisted: 'All shortlisted',
  allContacted: 'All contacted',
  allHidden: 'All hidden',
  allMatched: 'All matched',
  searchOverview: 'Search overview',
  campaignNotificationByEmail: 'Campaign email notifications',
  campaignNotificationDisabled: 'Disabled',
  campaignNotificationOnce: 'Once a day (at 08:00)',
  campaignNotificationTwice: 'Twice a day (at 08:00 and 16:00)',
  campaignNotificationThrice: 'Thrice a day (at 08:00, 12:00 and 16:00)',
  sendToNotificationTitle: 'Where to send the new/updated cadidates e-mail?',
  sendToNotificationPersonal: 'Personal E-mail only',
  sendToNotificationTeam: 'Team E-mail only',
  sendToNotificationBoth: 'Both team and Personal E-mails',
  askBeforeSpendingMonsterInventoryCredit: 'Ask before spending monster inventory credit?',
  /// TODO WERKZOEKEN: Remove this after release new jobboard
  // askBeforeSpendingWerkzoekenCredit: 'Ask before spending werkzoeken credit?',
  yesAskEveryTime: 'Yes, ask every time',
  noNeverAsk: 'No, never ask',
  browserExtension: 'Browser extension',
  robinExtension: 'Robin extension',
  adminPanel: 'Admin panel',
  intakePlanned: 'Matched',

  yes: 'Yes',
  no: 'No',
  areYouSure: 'Are You Sure?',
  confirmDeleteCampaign: 'Are you sure you want to delete this campaign?',
  by: 'by',
  in: 'in',
  you: 'you',
  here: 'here',
  syncing: 'Syncing...',
  syncingSuccessfully: 'Syncing successfully!',
  syncingFailed: 'Syncing failed!',
  match: 'Match',
  shortlistCandidateToOtherSearch: 'Shortlist to another search',
  shortlistCandidateNameToOtherSearch: (name) => `Shortlist candidate ${name} to other search`,
  shortlistCandidateToOtherSearchDescription:
    'Shortlist candidate for another search & keep in search results for the current search',

  matched: 'Matched',
  hidden: 'Hidden',
  shortlist: 'Shortlist',
  shortlisted: 'Shortlisted',
  unsaved: 'Unsaved',
  saved: 'Saved',
  connectToAts: 'Connect to ats',
  connectToAtsVacancy: 'Connect an ATS vacancy',
  unlocked: 'Unlocked',
  downloadProfiles: 'Download Profiles',
  history: 'History',
  activity: 'Activity',
  profileHistoryPlaceholder:
    'History information appears when you take actions on this candidate such as approving or rejecting.',
  details: 'Details',
  educationLevel: 'Education level',
  employer: 'Employer',
  travelDistance: 'Travel distance',
  availability: 'Availability',
  contactInfo: 'Contactable by',
  Monsterboard: 'Monsterboard',
  Nationalevacaturebank: 'Nationale Vacature Bank',
  Werknl: 'Werk.nl',
  version: 'Version',
  downloadAllApprovedCandidates: 'Download all approved candidates',
  downloadAllAMatched: 'Download all matched',
  maxOf300CandidatesWillBeDownloaded: 'Max of 300 candidates will be downloaded',
  searchForAts: 'Connect an ATS vacancy',

  iAlreadyKnow: 'I Already Know',
  overqualified: 'Overqualified',
  underqualified: 'Underqualified',
  wrongIndustry: 'Wrong Industry',
  wrongEducation: 'Wrong Education',
  wrongExperience: 'Wrong Experience',
  tooFarAway: 'Too Far Away',
  otherReasonNamely: 'Other, namely...',
  other: 'Other',
  hide: 'Hide',
  check: 'Check',

  contact: 'Contact',
  contacted: 'Contacted',
  calendarInterviewInvitationSent: 'Invitation sent, waiting on candidate',
  calendarInterviewInvitationAccepted: 'Interview booked',
  calendarInterviewInvitationRescheduled: 'Interview rescheduled',
  calendarInterviewInvitationRejected: 'Interview invitation rejected',
  calendarBookingStart: 'Start',
  calendarBookingDurationMinutes: (minutes: number) => `Duration: ${minutes} min`,
  positiveResponse: 'Positive Response',
  negativeResponse: 'Negative Response',
  noResponse: 'No Response',
  searching: 'Searching',
  sentToAts: 'Sent to ATS',
  sentToYourAts: 'Sent to your ATS',
  jobTitleAndLabel: (jobTitle: string, label: string) => `${jobTitle} and ${label}`,
  interviewScheduled: 'Interview scheduled',
  interviewBookedToastTitle: 'Interview booked',
  interviewBookedToastMessage: (name: string) => `${name} received the confirmation`,
  interviewPlaneed: 'Interview planeed',
  interviewCompleted: 'Interview completed',
  interviewCancelled: 'Interview Cancelled',
  leftVoicemail: 'Left voicemail',
  openToWorkNotInterested: 'Open to work, not interested',
  notOpenToWork: 'No longer available',
  noResponsiveToReachout: 'Not responsive to reach out',

  experience: 'Experience',
  courses: 'Courses',
  certifications: 'Certifications',
  reference: 'Reference',
  education: 'Education',
  skill: 'Skill',
  skills: 'Skills',
  language: 'Language',
  languages: 'Languages',
  volunteerWork: 'Volunteering',
  industry: 'Industry',
  company: 'Company',
  date: 'Date',

  whyRejected: 'Why Rejected?',
  whatIsTheStatus: 'What is the Status?',
  updateStatus: 'Update status',

  explanation: 'Explanation',
  nameSearch: 'Name your search',
  vacancy: 'Vacancy',
  vacancyPlaceholder: 'e.g. https://careers.recruitrobin.com/account-manager',
  jobTitle: 'Job title',
  jobTitles: 'Job titles',
  jobTitlesTooltip: (
    <span>
      The * can be placed at the beginning and/or end of a word to search for multiple variations. For example:
      <ul>
        <li>*Operator returns results such as "Forklift Operator" and "Production Operator"</li>
        <li>Logistiek* returns results such as "Logistiek Supervisor" and "Logistiek Medewerker"</li>
        <li>*Warehouse* returns results such as "Warehouse Employee" and "Supervisor Warehouse "</li>
      </ul>
    </span>
  ),
  jobDescription: 'Job description',
  robinJrSuggestions: 'Robin JR. suggestions:',
  insert: 'Insert',
  saveAndSubmit: 'Save and Submit',
  addSuggestions: (number: number) => `Add ${number} suggestions`,
  jobTitlePlaceholder: 'e.g. Engineer',
  addJobTitlePlaceholder: 'Add job title',
  jobTitleWarning: 'Having only one job title will likely generate very few results.',
  workExperience: 'Work experience in years',
  minWorkExperienceInYears: 'Min. Work Experience in Years',
  maxWorkExperienceInYears: 'Max. Work Experience in Years',
  minWorkExperienceInFunction: 'Min. Experience in Function',
  screeningCriteria: 'Screening criteria',
  screeningCriteriaPlaceholder: '',
  country: 'Country',
  postalCode: 'Postal Code',
  rangeInKm: 'Range in KM',
  startSearch: 'Start Search',
  editSearch: 'Edit Search',
  eg: 'E.g.',
  errorDuplicatedJobTitle: 'Job title already exists. Please enter a unique job title',

  veryWell: 'Very Well!',
  iWillStartLookingForCandidates: (campaignName) => (
    <Fragment>
      I'll start looking for candidates for your job offer <span>{campaignName}</span>
    </Fragment>
  ),
  whatToExpect: 'What to expect',
  whatToExpect1: 'Within 4-24 hours an overview of potential candidates.',
  whatToExpect2: 'I will keep you posted during the coming phases via e-mail.',
  editThisCampaign: 'Edit this Campaign',
  viewCampaigns: 'View Campaigns',
  searchForCampaign: 'Search for Campaign',
  ratioOfApprovedCandidates: (approved: number, total: number) => (
    <Fragment>
      <strong>{approved}</strong> of <strong>{total}</strong> matched
    </Fragment>
  ),
  seeResults: 'See results',
  notAbleDeleteSearchAts: 'You cannot delete a search related to your ATS',

  more: 'More',
  move: 'Move',
  moveTo: 'Move To',

  contactInfoSetting: 'Only show candidates with contact information',
  activeJobSeekersSetting: 'Only show active job seekers',
  newLink: 'new link',
  insertLink: 'Insert link',
  displayText: 'Display text',
  URL: 'URL',
  removeLink: 'Remove link',
  attachFile: 'Insert a File',
  tokensEmpty: 'Tokens are empty',

  //Job Boards
  newJobBoard: 'New Job Board',
  editJobBoard: 'Edit Job Board',
  invalidCredentials: 'Invalid Credentials',
  validATSCredentials: 'Valid Credentials',
  invalidMfaCode: 'This verification token is invalid or expired',
  credentialsExpired: 'The credentials are expired. Please, insert you username and password again',
  jobBoardCredentialVerificationTitle: 'Verifying your credentials.',
  jobBoardCredentialVerificationDescription:
    'Please wait a moment, live verification of credentials can take up to a minute.',
  jobBoardInvalidCredentials:
    'Sorry, we could not verify your credentials, check your username and password and try again.',
  jobBoardDuplicatedCredentials: 'Your credentials are already saved.',
  jobBoardConnectionActive: 'Job board connection is active.',
  jobBoardConnectionInActive: 'Job board connection is not active.',
  confirmDeleteJobBoard: 'Are you sure you want to delete this Job Board?',
  confirmDisableJobBoard: 'Are you want to disable this job board for all users?',
  jobBoardExplanation: 'Choose the job board you would like to connect with\n',
  jobBoardUsernameExplanation: 'Enter the username you use to login onto the job board.',
  jobBoardPasswordExplanation: 'Enter the password you use to login onto the job board.',
  jobBoardSecret: 'Security Question',
  jobBoardSecretExplanation: 'Enter the secret question answer you use to login onto the job board.',
  licenseActive: 'Your credential is active.',
  licenseInActive: 'Your credential is not active.',
  license: 'License',
  addLicense: 'Add License',

  //ATS
  addNew: 'Add New',
  atsVacancy: 'ATS Vacancy',
  viewATSConnections: 'View ATS Connections',
  unableToConnectToATS: 'Unable to connect to your ATS. Please check your credentials or try again later.',
  myConnections: 'My Connections',
  teamConnections: 'Team Connections',
  usersWithoutConnections: 'Users Without Connections',
  atsKey: 'ATS Key',
  atsUrl: 'ATS URL',
  atsName: 'ATS Name',
  atsCompleteName: 'Applicant tracking system',
  clientSecret: 'Client Secret',
  requestATSConnection: 'This ATS is not yet registered in our sytem. Request a connection, so we can add the ATS.',
  atsRequestedMessage: (
    <Fragment>
      The connection is requested. We are on it! In the meanwhile you can continue with creating searches and judging
      candidates.
      <br />
      <br />
      Whenever we know if it's possible to connect with the ATS you requested, we will contact you.
    </Fragment>
  ),
  checkOverview: 'Check Overview',
  confirmDeleteATS: "Deleting this connection means your candidates won't be pushed to your ATS anymore.",
  confirmSwitchATS: (ats) => `You are already connected to ${ats}. Are you sure you would like to switch?`,
  atsExplanation: 'Choose the ATS you would like to connect with',
  atsUsernameExplanation: 'Enter the username you use to login to the ATS',
  atsPasswordExplanation: 'Enter the password you use to login to the ATS',
  atsKeyExplanation: "Enter the ATS Key you find in your ATS' settings",
  atsSecret: 'Client secret',
  atsSecretExplanation: 'Enter the client secret you fin',
  atsConnectionAltTitle: (id, name) => `ATS connection ${id} to ${name}`,
  recruiteeWebhookInstruction:
    'Copy the Webhook URL below into Recruitee (Settings → Apps and Plugins → Webhooks), then paste the Secret shown in Recruitee into the field below.',
  webhookUrl: 'Webhook URL',
  webhookSecret: 'Webhook Secret',
  seeDetails: 'see details',
  /// ATS Credentiasl error Modal
  showMoreErrorDetails: 'Show more error details',
  atsCredentialsErrorModalBody: 'ATS connection replied with reason:',
  atsPermissionOk: 'Permission OK',
  atsPermissionInvalid: 'Permission Invalid for this resource (please request access)',

  campaignCompletedTitle: 'Doing Well!',
  campaignCompletedMessage: (
    <Fragment>
      You've reviewed all available candidates.
      <br />
      <br />
      Search again or edit your current search so we can look for more relevant candidates.
    </Fragment>
  ),
  campaignGroup1CompletedMessage: (
    <Fragment>
      You've reviewed all candidates. I have 25 more candidates that fit most, but not all of your search criteria.
      These candidates could be relevant for you. Would you like to review them?
      <br />
      <br />
      Alternatively, you can edit your current search so we can start searching for more candidates.
    </Fragment>
  ),
  searchingMoreProfiles: 'Searching More Profiles.',
  searchAgain: 'Search Again',
  reviewAlternativeCandidates: 'Review Alternative Candidates',

  mustBeMoreThanMin: 'Must be more than min',
  mustBeLessThanMax: 'Must be less than max',

  // common
  any: 'Any',
  of: 'of',
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  activate: 'Activate',
  deactivate: 'Deactivate',
  close: 'Close',
  remove: 'Remove',
  exclude: 'Exclude',
  mustHave: 'Must Have',
  saving: 'Saving...',
  done: 'Done!',
  loading: 'Loading',
  thisCouldTakeAFewMinutes: 'This could take a few minutes.',
  changesSaved: 'Changes saved',
  invalidUsername: 'Invalid Username',
  invalidPassword: 'Invalid Password',
  clickHere: 'Click here',
  selectAll: 'Select All',
  selectAllCandidatesWithRj: 'Select all candidates with Rj',
  selectCandidates: 'Select candidates',
  rjBulkSelectAllDailyLimitTooltip: "You've reached today's limit for bulk RJ outreach.",
  runRjAmount: (value: number) => `Run Rj (${value})`,
  rjBulkOutreachesUsagePillLabel: (used: number, total: number) => `${used}/${total} bulk outreaches today`,
  amountLeftToday: (value: number) => `${value} left today`,
  rjBulkDailyContactLimitDescription: (value: number) =>
    `You can contact up to ${value} candidates at once per day with Rj`,
  rjBulkOutreachesLeftToday: (value: number) => `You have ${value} bulk outreaches left today`,
  rjBulkDailyLimitReachedQuotaResetsTomorrow: "You've reached today's limit · your quota resets tomorrow",
  candidatesSelectedCount: (value: number) => `${value} candidate${value > 1 ? 's' : ''} selected`,
  clearAll: 'Clear All',
  scrollTo: 'Scroll To',
  otherwiseNamely: 'Otherwise, namely ...',
  somethingWentWrong: 'Something went wrong',
  pleaseTryAgainOrContactUs: 'Please try again. If the problem persists contact us.',
  indeedCandidateAlreadyContacted: 'This candidate was already contacted recently',
  indeedCandidateRecentlyDeclined: 'This candidate received an engagement recently and was not interested',
  notFound: 'Not Found',
  loggingYouInAutomatically: 'Logging You in Automatically',
  couldNotLogYouInAutomatically: 'Could not log you in Automatically',
  attemptNofX: (current: number, max: number) => `Attempt ${current} of ${max}.`,
  minimumCharacterValue: (value) => `A minimum of ${value} characters is required`,
  maximumCharacterValue: (value) => `The maximum number of characters is ${value}`,
  companyNameCannotContainSpecialCharacters: 'Your company name cannot have spaces or special characters.',
  selectAnOption: 'Please select an option',
  and: 'and',
  or: 'or',
  expandLess: 'Expand less',
  expandMore: 'Expand more',
  downloadProfile: 'Download profile',
  tutorial: 'Tutorial',
  emailSuccessfullySent: 'Your email was successfully sent!',
  emailFailedSend: 'Your email failed to send!',
  linkedinSuccessfullySent: 'Your LinkedIn request was successfully sent!',
  linkedinFailedSend: 'Your LinkedIn request failed to send!',
  linkedinInMailSuccessfullySent: 'Your LinkedIn InMail was successfully sent!',
  liknedinInMailFailedSend: 'Your Liknedin Inmail failed to sent!',
  indeedSuccessfullySent: 'Your Indeed message was successfully sent!',
  indeedFailedSend: 'Your Indeed message failed to sent!',

  //Languages
  english: 'English',
  dutch: 'Dutch',

  //Users
  actions: 'Actions',
  exportToExcel: 'Export to Excel',
  createNewUser: 'Create new user',
  manageUsers: 'Manage users',
  userUnlock: 'Unlock',
  userActivationSettings: 'Activation settings',
  isActive: 'Is active',
  lastLoggedIn: 'Last login time',
  userSince: 'User since',
  emailConfirmed: 'Email confirmed',

  userDeactivateConfirmation: 'Are you sure you want to deactivate this user?',
  userActivateConfirmation: 'Are you sure you want to activate this user?',
  userWasUnlockedSuccessfully: 'User unlocked successfully',
  userWasDeletedSuccessfully: 'User deleted successfully',
  userCreatedSuccessfully: 'User created successfully',
  userProfileUpdatedSuccessfully: 'User updated successfully',
  userWasActivatedSucessfully: 'User activated successfully',

  editUser: 'Edit user',
  invalidEmailAddress: 'Please enter a valid Email.',
  invalidPhoneNumber: 'Please enter a phone number.',
  atLeast6Characters: 'Requires at least 6 characters',
  atLeast12Characters: 'Requires at least 12 characters',
  passwordMustContainDigit: 'Requires at least 1 digit',
  passwordMustContainUppercase: 'Requires at least 1 uppercase letter',
  passwordMustContainLowercase: 'Requires at least 1 lowercase letter',
  passwordIsTheSame: 'Password cannot be the same as the previous password',

  userPasswordSettings: 'Password settings',
  setNewPassword: 'Set password',
  setRandomPasswordForUser: 'Set random password.',
  shouldChangePasswordOnNextLogin: 'Should change password on next login',
  sendActivationEmail: 'Send activation email',
  setUserIsActive: 'Active',
  setLockOut: 'Lockout enabled',
  remindPassword: 'If you can not remember your password,',
  incorrectPassword: 'Incorrect Password',
  passwordsDoNotMatch: "Passwords don't match",

  //While the user is logged out
  emailActivation: 'Email Activation',
  emailActivationDescription:
    "A link will be sent to your email to activate your email address. If you don't get an email within a few minutes, please re-try.",
  emailActivationSentDescription: 'An e-mail activation link sent to your e-mail address. Please check your emails.',

  invalidResetLink: 'Invalid Reset Link',
  invalidResetLinkDescription: 'The reset link you used is not valid',
  passwordResetComplete: 'Password Reset Complete',
  goToLogin: 'Go to Log In Page',
  goToLoginDescription: 'You may now log in with your new password',

  companyNameIsTaken: 'This company name is already taken. Please try it again with a different company name.',

  //Realtime Search filters
  activeFilters: (num) => `${num} active filter${num === 1 ? '' : 's'}`,
  filters: 'Filters',
  totalExperience: 'Total experience',
  location: 'Location',
  locations: 'Locations',
  locationsPlaceholder: 'e.g. Utrecht',
  skillsKeywords: 'Skills / Keywords',
  skillsKeywordsPlaceholder: 'e.g. Excel',
  mustHaveEmail: 'Must Have Email',
  mustHavePhone: 'Must Have Phone',
  sources: 'Source',
  schoolName: 'Schools attended',
  schoolNamePlaceholder: 'e.g. Utrecht University',
  educationDegree: 'Education degrees',
  educationDegreePlaceholder: 'e.g. Bachelors',
  educationFields: 'Education fields',
  educationFieldsPlaceholder: 'e.g. Human Resource Management',
  sizeOfBatches: 'Size of batches',
  locationDistanceInKm: 'Location distance (km)',
  industries: 'Industries',
  aboutMe: 'About Me',
  licenses: 'Licenses',
  searchResults: 'Search results',
  updatedAt: 'Updated At',
  graduationYear: 'Latest education',
  employmentType: 'Employment type',

  //Updated At Filter
  anyTime: 'Any time',
  last24Hours: 'Last 24 Hours',
  last3Days: 'Last 3 Days',
  lastWeek: 'Last Week',
  lastMonth: 'Last Month',
  last3Months: 'Last 3 Months',
  last6Months: 'Last 6 Months',
  lastYear: 'Last Year',

  //Employment Type Filter
  employmentTypeFullTime: 'Full time',
  employmentTypePartTime: 'Part time',
  employmentTypeInternship: 'Internship',
  employmentTypeFreelance: 'Freelance',
  employmentTypeShortTerm: 'Short term',
  employmentTypeSeasonal: 'Seasonal',

  //Job Title Type Filter
  jobTitleType: 'When experience happened',
  jobTitleTypeAll: 'Any time',
  jobTitleTypeCurrent: 'Latest role',
  jobTitleTypeRecent: 'Latest two roles',
  jobTitleTypePast: 'Past roles',

  //Realtime Search Results
  candidatePreferences: 'Candidate Preferences',
  interests: 'Interests',
  source: 'Source',
  lastUpdated: 'Last updated',
  lastCrawled: 'Last refreshed',
  lastMatched: 'Last matched',
  lastContacted: 'Last contacted',
  lastHidden: 'Last hidden',
  lastShortlisted: 'Last shortlisted',
  couldNotRefreshProfile:
    'We cannot refresh this profile at this time. The profile may have been deleted at the source. Please try again later.',
  profileNotAvailable:
    'We cannot refresh this profile at this time because the profile has been deleted at the source.',
  phone: 'Phone',
  academicExperience: 'Academic Experience',
  addSomeFiltersMessage: 'Add some filters to start your search!',
  noResultsMessage:
    'We found no candidates for the filters you requested. Try changing the filters or use the chat if you need help!',
  openToWork: 'Open to Work',
  credentialsDisabledCallToAction: (platform: string) =>
    `Your credentials for ${platform} are not working. Please update them, so you don't miss out on candidates from ${platform}.`,
  autoSavedFilters: 'Auto-saved Filters',

  helpCenter: 'Help center',
  help: 'Help',

  notifications: 'Notifications',
  markNotificationAsRead: 'Mark notification as read',
  markAllAsRead: 'Mark all as read',
  seeSearchInList: 'See search in list',
  year: 'year',
  years: 'years',
  month: 'month',
  months: 'months',
  inTotal: 'in total',
  inFunction: 'in function',
  viewFullProfile: 'View Full Profile',
  pleaseWait: 'Please Wait',
  downloadCV: 'Download CV',
  downloadCVs: 'Download CVs',
  pageNumOfNum: (current: number | string, total: number | string) => `Page ${current} of ${total}`,
  issued: 'Issued',
  resume: 'About',
  licensesAndCertifications: 'Licenses & Certifications',
  jobs: 'Jobs',
  minWorkHours: 'Min. work hours',
  maxWorkHours: 'Max. work hours',
  minSalary: 'Min. salary',
  maxSalary: 'Max. salary',
  currency: 'Currency',
  unlockContactInformation: (price: number) => `Unlock contact information (${price} credit${price >= 2 ? 's' : ''})`,
  saveAndUnlockContactInformation: (price: number) =>
    `Save and unlock contact information (${price} credit${price >= 2 ? 's' : ''})`,
  unlockCV: (price: number) => `Unlock CV (${price} credit${price >= 2 ? 's' : ''})`,
  currentOfTotal: (current: number | string, total: number | string) => `${current} of ${total}`,
  showMore: 'show more',
  showLess: 'show less',
  showXMore: (quantity) => `Show ${quantity} more`,
  showXLess: (quantity) => `Show ${quantity} less`,
  showAll: (quantity) => `Show all (${quantity})`,
  plusMore: (quantity) => `+${quantity} more`,
  requestContactInformation: 'Request contact information',
  youCanRequestContactInformation:
    'You can request contact information. We will charge one credit if we succeed to find one.',
  thisProfileWasUpdatedTimeAgo: (timeAgo) => `This profile was updated ${timeAgo}`,
  thisProfileWasRefreshedTimeAgo: (timeAgo) => `This profile was refreshed ${timeAgo}`,
  thisProfileWasApprovedTimeAgo: (timeAgo) => `This profile was approved ${timeAgo}`,
  loading_ats_synchronization_label: 'ATS Synchronization',
  loading_contact_info_label: 'Contact Info',
  reTriggerATSCandidateSync: 'Retry send candidate to ATS',
  errorSectionTitle: 'Error',
  errorSectionMissingSkillOrFunction: 'You should specify a skill or function title or location',
  hideFromApproved: 'Hide from approved',
  userFormGenericError: 'Something went wrong while saving the user',
  userFormEmailAlreadyTakenError: 'The e-mail @email is already taken',
  duplicate: 'Duplicate',
  copyOf: 'Copy of',
  clickHereToUpdateSearch: 'Click here to update the search results with your new filters',
  orSimplyPress: ({ isMacOs = false }) => (
    <Fragment>
      Or simply press&nbsp;<code>{isMacOs ? 'Cmd' : 'Ctrl'} + Enter</code>
    </Fragment>
  ),

  // Teams
  team: 'Team',
  teams: 'Teams',
  teamName: 'Team name',
  teamUsers: 'Users in team',
  manageTeams: 'Manage teams',
  createNewTeam: 'Create new team',
  createdBy: 'Created by',
  createdAt: 'Created at',
  editTeam: 'Edit team',
  teamDeletionConfirmation: 'Are you sure you want to delete this team? This action cannot be undone.',
  teamWasDeletedSuccessfully: 'Team deleted successfully',
  teamCreatedSuccessfully: 'Team created successfully',
  teamUpdatedSuccessfully: 'Team updated successfully',
  editTenantEmailSettingsExplanation:
    "This configuration only works when you don't have a team. You can set a notification configuration for a team individually. Anything set within a specific team will override the settings defined here.",
  editTenantEmailSettingsBtn: 'Company notification email',
  editTenantEmailSettings: 'Edit company notification email settings',
  tenantEmailSettingsCreatedSuccessfully: 'Company notification email settings successfully created',
  tenantEmailSettingsUpdatedSuccessfully: 'Company notification email settings successfully updated',
  joinTeamSuccessfully: 'You joined the team',
  exitTeamSuccessfully: 'You left the team',
  join: 'Join',
  leave: 'Leave',
  detailsTeam: 'Team details',

  updateContactInformation: 'Update contact information',
  contactInfoAvailableFrom: (platform: string) => `Contact info available from ${platform}`,
  requestHere: 'Request here',
  refreshHappensAutomatically: 'Refreshing now happens automatically',
  notificationJobbboardNewVersion: (platform: string) =>
    `A brand new ${platform} integration has been released, please contact us about getting connected to continue seeing the latest ${platform} candidates.`,

  requestJobboardInformationConfirmationTitle: (platform: string) =>
    `Request candidate contact information from ${platform}`,
  requestJobboardInformationConfirmationDescription: (platform: string) =>
    `This will use a ${platform} Credit, are you sure you want to request this information?`,
  requestJobboardInformationConfirmationCancelText: 'Cancel info request',
  requestJobboardInformationConfirmationConfirmText: 'Request contact info',

  dontPerformThisCheckNextTime: "Don't perform this check next time",

  candidateNotFoundTitle: 'Unfortunately the candidate you are looking for is no longer available',
  candidateNotFoundSubtitle: 'They have removed their profile at the source.',

  /// Platforms
  indeed: 'Indeed',
  linkedIn: 'LinkedIn',
  linkedInInMail: 'LinkedIn InMail',
  whatsApp: 'WhatsApp',

  /// Contact Modal
  chooseContactTitleModal: 'Choose a contact method',
  chooseContactDescriptionModal: (name) => `Select how you want to contact ${name}`,
  writeEmailTo: (name) => `Write your email to ${name}`,
  writeMessageTo: (name) => `Write your message to ${name}`,
  sendWithWhatsAppWeb: 'Send with WhatsApp Web',
  sendWithIndeed: 'Send with Indeed',
  sendLinkedInRequest: 'Send LinkedIn connection request',
  sendMessage: 'Send message',
  sendInMail: 'Send Linkedin InMail',
  sentWhatsAppTo: (name: string) => `Whatsapp message sent to ${name}`,
  emailSent: 'Email sent',
  emailReceived: 'Email received',
  emailReceivedFrom: (name: string) => `Email received from ${name}`,
  reply: 'Reply',
  indeedSent: 'Indeed sent',
  indeedReceived: 'Indeed received',
  indeedJobDropdownPlaceholder: 'Attach a job',
  indeedNoJob: 'No job attachment',
  indeedNoJobsFound: 'No job vacancies found.',
  indeedProjectDropdownPlaceholder: 'Select a project',
  whatsappSent: 'Whatsapp sent',
  linkedinConnectionSent: 'LinkedIn connection sent',
  linkedinInmailSent: 'LinkedIn Inmail sent',
  sentEmailTo: (name: string) => `Email sent to ${name}`,
  sentOutreachMessageTo: (channel: string, candidateName: string) => `${channel} sent to ${candidateName}`,
  sentIndeedTo: (name: string) => `Indeed message sent to ${name}`,
  sentLinkedInTo: (name: string) => `Linkedin connection sent to ${name}`,
  sentLinkedInMailTo: (name: string) => `Linkedin InMail sent to ${name}`,
  sentWerknlMailTo: (name: string) => `Werknl message sent to ${name}`,
  sentBy: 'Sent by:',
  sendDisabledIndeedTip: 'You must connect your Indeed account to send this message',
  sendDisabledLinkedinTip: 'You must connect your LinkedIn account to send this message',

  callingWith: (candidateName) => <>Calling with {candidateName}</>,
  sendEmailTo: (candidateName) => `Send Email to ${candidateName}`,
  sendWhatsAppMessageTo: (candidateName) => `Send WhatsApp message to ${candidateName}`,
  sendIndeedMessageTo: (candidateName) => `Send Indeed message to ${candidateName}`,
  replyIndeedMessageTo: (candidateName) => `Reply Indeed message to ${candidateName}`,
  sendWerknlMessageTo: (candidateName) => `Send Werk.nl message to ${candidateName}`,
  newLinkedinMessageTo: (candidateName) => `New LinkedIn message to ${candidateName}`,
  newLinkedinInMailMessageTo: (candidateName) => `New LinkedIn InMail message to ${candidateName}`,

  /// Connect Phone Modal
  connectYourPhoneTitleModal: 'Connect your phone to WhatsApp',
  connectYourPhoneDescriptionModal:
    "To send messages via WhatsApp, please use the desktop app. Download and install the app on your computer and connect your mobile phone. After this you're ready to go!",
  showMeHow: 'Show me how',
  dontShowThisAgain: "Don't show this again",
  imConnected: "I'm connected",
  downloadTheApp: 'Download the app',

  /// Browser Extension Modal
  browserExtensionRequired: 'Browser extension required',
  browserExtensionRequiredDescriptionModal:
    "To send Indeed or LinkedIn messages you must have our browser extension installed so we can communicate with those platforms. We've noticed you don't have the extension, so please install this first.",
  installTheExtension: 'Install the extension',

  /// Confirm Message Modal
  confirmMessageTitleModal: 'Did you successfully send your message?',
  confirmMessageDescriptionModal:
    'Let us know if you successfully sent the message or not so we can organise where to put the candidate for you!',
  messageNotSent: 'Message not sent',
  generatingMessage: (name) => `Generating message for ${name}...`,
  errorGeneratingMessage: (candidateName) => `Failure to generate message for ${candidateName}`,
  failureToSendMessageTo: (name) => `Failure to send message to ${name}`,
  messageSent: 'Message sent',

  /// Confirm Call Modal
  confirmCallTitleModal: (name) => `Did ${name} pick up the phone?`,
  confirmCallDescriptionModal:
    'Let us know if your call was successful or not so we can organise where to put the candidate for you!',
  couldntConnect: 'Not Contacted',
  connected: 'Contacted',
  callSaved: 'Call Saved',

  /// Fields tips
  campaignNotificationByEmailTip: 'Enable receiving notifications of new candidates found for your campaigns',
  nameSearchTip: 'Provide a clear name that you can easily recognise, your team will also use this!',
  jobTitleTip: 'Add a relevant job title to search for, we then suggest 10 more relevant titles',
  jobTitleTypeTip: 'When the above positions were worked by the candidate',
  locationDistanceInKmTip: 'Adjust the slider to set the desired radius in kilometers.',
  contactInfoTip: 'When both options are checked, only candidates that have both on their profile will be shown',
  totalExperienceTip: 'How many years the candidate has been working in total',
  languagesTip: 'What languages the candidate needs to know for the role',
  lastUpdatedTip: 'When the candidates profile was last updated on the job boards',
  graduationYearTip: 'When the candidate had last received education of any form',
  schoolNameTip: 'What educational institutes the candidate should have attended',
  educationDegreeTip:
    'This is a degree the candidate needs to have but it is not necessarily the highest or only degree they have',

  /// Admin
  backToSearchCampaigns: 'Back to search campaigns',
  createNewCompany: 'Create a new company',
  editCompany: 'Edit company',
  editUsers: 'Edit users',
  impersonateUser: 'Impersonate user',
  creditLimit: 'Credit limit',
  updateUsersSuccessfully: 'Users has been updated successfully',
  id: 'Id',
  companyCode: 'Company Code',
  edition: 'Edition',
  active: 'Active',
  inactive: 'Inactive',
  credits: 'Credits',
  created: 'Created',
  updated: 'Updated',
  demo: 'Demo',
  standard: 'Standard',
  tenantHasBeenUpdatedSuccessfully: 'Tenant has been updated successfully',
  tenantHasBeenCreatedSuccessfully: 'Tenant has been created successfully',
  tenantName: 'Tenant name',
  removeSpaces: 'Remove spaces',
  subscriptionEdition: 'Subscription edition',
  editTenantUsers: 'Edit tenant users',
  editTenantUsersSubtitle: 'The first user in this list is the admin user and is required.',
  name: 'Name',
  firstName: 'First name',
  lastName: 'Last name',
  fullName: 'Full name',
  lastPosition: 'Last position',
  lastCompany: 'Last company',
  recruiterFullName: 'Recruiter full name',
  nameJobboard: 'Name Jobboard',
  nameVacancy: 'Name Vacancy',
  addAnotherUser: 'Add another user',
  impersonate: 'Impersonate',
  searchCompany: 'Search company',
  entriesPerPage: 'Entries per page',

  matchPhase: 'Match phase',
  none: 'None',

  website: 'Website',

  typeYourMessage: 'Type your message...',
  typeYourMessageRobinJr: 'Type your text or select a job, and AI will generate the perfect one...',
  selectHighQualityJob: "Select 'High Quality' job for 70% conversion reply.",
  typeYourNote: 'Type your note...',
  subject: 'Subject',
  signOff: 'Sign off,',
  featureToggles: 'Feature toggles',
  addFeatureToggle: 'Add feature toggle',
  title: 'Title',
  value: 'Value',
  enabled: 'Enabled',
  emptySubject: 'You have not entered a subject',
  emptyMessage: 'You have not entered a message',
  emptySignOff: 'You have not entered a greeting',
  yearAbbr: 'yr',
  yearsAbbr: 'yrs',
  simplified: 'Simplified',
  addLabels: 'Add labels',
  addLabel: 'Add label',
  labelAdded: 'Label added',
  noteAdded: 'Note added',
  fresh: 'Fresh',
  candidateHasXNotes: (labelsCount) => `Candidate has ${labelsCount} notes`,

  // Candidate Insights
  newCandidate: 'New candidate',
  updatedInformation: 'Updated information',
  educationAddedRecently: 'Education item added',
  educationDatesChanged: 'An education date was changed',
  educationEditedRecently: 'An education was changed',
  experienceAddedRecently: 'Experience added recently',
  jobRoleChanged: 'A job role was changed',
  jobDescriptionChanged: 'A job description was changed',
  jobDatesChanged: 'A job date was changed',
  skillAddedRecently: 'Skill added recently',
  preferredEmploymentTypeChanged: 'Preferred employment type changed',
  preferredWorkHoursChanged: 'Preferred work hours changed',
  workAvailabilityChanged: 'Work availability changed',
  locationChangedRecently: 'Location changed recently',
  phoneAddedRecently: 'Phone added recently',
  phoneNumberChanged: 'Phone number changed',
  emailAddedRecently: 'Email added recently',
  emailChanged: 'Email changed',

  latestActions: 'Latest actions:',
  titlePlaceholder: 'Name your search',
  refineTheSearchBelow: 'Refine the search below',

  indeedNoCredits: 'Your Indeed account does not have credits to send an Indeed Email',
  indeedCreditsUnknown: 'Credits unknown',
  indeedCreditsOutOfSync: 'Credits may be out of sync',
  indeedCreditsOutOfSyncDescription:
    'This number is updated periodically and may not reflect your current Indeed balance.',
  indeedCheckBalance: 'Check your balance on Indeed',
  linkedinNoCredits: 'Your LinkedIn account does not have credits to send a LinkedIn InMail',

  createNewTemplate: 'Create new template',
  nameYourTemplate: 'Name your template',
  blankTemplate: 'Blank template',

  saveTemplate: 'Save template',
  selectTemplateToUse: (type) => `Select a ${type} template to use`,
  templateSavedSuccessfully: 'Template saved successfully!',
  templateTokens: 'Personalization tokens',
  lastActioned: 'Last actioned',
  oldestActioned: 'Oldest actioned',
  haveSeenItAll: 'Yay! You have seen it all!',
  sharedByFromSearch: ({ userName, searchName }) => (
    <>
      Shared by {userName} from {searchName}
    </>
  ),
  copyLinkCandidateProfile: 'Copy a link to the candidate profile',
  linkCopySuccess: 'Link copied!',
  linkCopyFail: 'Link copy failed',
  youNotHaveAccessProfile: 'You do not have access to this candidate profile',
  tryResendAts: 'Try to resend candidate to ATS',

  emailAndPhoneAvailableUponApproval: (email, phone) => {
    if (email && phone) {
      return `${dictionary.email} and ${dictionary.phone} available upon approval`;
    }

    if (phone) {
      return `${dictionary.phone} available upon approval`;
    }

    return `${dictionary.email} available upon approval`;
  },

  cvAvailableUponApproval: 'CV available upon approval',

  changeOwner: 'Change owner',
  currentOwner: 'Current owner',
  makeUserSearchOwner: (userName) => `Make ${userName} the search owner?`,
  makeUserSearchOwnerDescription: (
    userName,
  ) => `You will no longer be the owner of the search as ${userName} will replace you.
  `,
  goAhead: 'Go ahead!',
  currentSearch: 'Current search',
  labelsChanged: 'Labels changed',
  notes: 'Notes',
  deleteNote: 'Delete note',
  editNote: 'Edit note',
  startTypingYourNotesHere: 'Start typing your notes here...',
  moreInfoSent: 'More info sent',
  noAnswer: 'No answer',
  notResponding: 'Not responding',
  notInterested: 'Not interested',
  interested: 'interested',
  showQuestionnaire: 'Show questionnaire',
  declined: 'declined',
  positiveOutcomes: 'Positive outcomes',
  neutralOutcomes: 'Neutral outcomes',
  negativeOutcomes: 'Negative outcomes',
  customLabels: 'Custom labels',
  createCustomLabel: 'Create custom label',
  removed: 'Removed',
  paymentMethod: 'Payment method',
  triggerToSendCandidateToAts: 'Trigger to send candidate to ATS',
  chooseAnOption: 'Choose an option',
  selectATemplateToUse: (type) => {
    if (type === 'email') return 'Select an email template to use';
    if (type === 'indeed') return 'Select an Indeed template to use';
    if (type === 'linkedin') return 'Select a LinkedIn template to use';
    if (type === 'whatsapp') return 'Select a WhatsApp template to use';
    if (type === 'werknl') return 'Select a Werknl template to use';
    return 'Select a phone template to use';
  },
  templates: 'Templates',
  templateName: 'Template name',
  nameTheTemplate: 'Name the template',
  newOutreach: 'New outreach',
  content: 'Content',
  connectYourCalendar: 'Connect your calendar',
  configureYourCalendar: 'Configure your calendar',
  openSettings: 'Open settings',
  calendarSettings: 'Calendar settings',
  yourCalendarIsConnected:
    'Your calendar is connected. Update your availability, working hours, and interview preferences here.',
  yourCalendarIsNotConnected: 'Your calendar is not connected',
  toUseInterviewScheduler:
    'To use the interview scheduler, please connect your calendar. This lets Robin show your availability, prevent double bookings, and send invites automatically.',
  signature: 'Signature',
  signatureSave: 'Save the signature',
  signaturePlaceholder: 'Enter your signature here...',
  signatureDescription: 'Customize your email signature for outgoing messages.',
  signatureImageHelper: 'We only support jpeg and png',
  signatureSaving: 'Saving signature',
  signaturePullButton: 'Import signature',
  signaturePullErrorTitle: "We couldn't import your signature",
  signaturePullErrorBody: (
    <span>
      Unfortunately, we weren't able to fetch your signature from your last email.
      <br />
      No worries, you can still add it manually using our step-by-step guide.
    </span>
  ),
  addManually: 'Add manually',
  addSignatureManually: 'Add signature manually',
  enableProviderFirst: 'Connect your email first!',
  signatureSaveError: 'Signature could not be saved',
  signatureSaveErrorImageConversion:
    'The signature could not be saved due to an error related to the images embedded in the HTML',
  signatureSaveSuccess: 'Signature was saved successfully',
  manualSignatureSelectionTitle: 'Select your signature',
  manualSignatureSelectionDescription: (
    <Fragment>
      We couldn’t find your signature automatically.
      <br />
      Please select one of your recent emails below, highlight the signature area, and click Insert Signature.
      <br />
      Need help?{' '}
      <a
        href="https://help.recruitrobin.com/nl/articles/11060587-e-mailhandtekening-importeren-in-robin"
        target="_blank"
        rel="noreferrer">
        Learn how to import your signature
      </a>
    </Fragment>
  ),
  manualSignatureSelectionCapture: 'Capture selection',
  manualSignatureSelectionInsert: 'Insert signature',
  manualSignatureSelectionPreview: 'Preview of your selection:',
  manualSignatureSelectionHighlightError: 'Please highlight the signature area first',
  calling: 'Calling',
  candidateNotes: 'Candidate notes',
  successfull: 'Successfull',
  candidateSentToAts: (candidateFirstName: string, atsName: string) => (
    <Fragment>
      {candidateFirstName} is moved to matched
      <br />
      and added directly to {atsName}
    </Fragment>
  ),
  unsuccessfull: 'Unsuccessfull',
  findMoreGreatCandidates: 'Find more great candidates',
  tryAnotherOutreachMethod: 'Try another outreach method',
  outreachPhoneSuccessfullHeaderText: 'Great work, what was the outcome of your conversation?',
  outreachPhoneUnsuccessfullHeaderText: 'Sorry to hear your call was unsuccessful. What was the problem?',
  filterByLabel: 'Filter by label',
  atsJobStatusesSelectionLabel: 'Job statuses to sync',
  atsJobLabelsSelectionLabel: 'Job labels to sync',
  outreachResponseNoticeEmail: 'We email on your behalf. All messages are in your Robin inbox',
  outreachResponseNoticeWhatsApp: 'WhatsApp replies will appear directly in your personal WhatsApp app',
  outreachResponseNoticeInMail: 'InMail replies will appear directly in your LinkedIn account',
  outreachResponseNoticeLinkedIn: 'Replies to LinkedIn connection requests will appear in LinkedIn as well as in Robin',
  outreachResponseNoticeIndeed: 'You will receive responses from indeed in Robin',
  outreachResponseNoticeWerknl: (
    <span>
      Sent werk.nl message do not appear in your outbox because we send messages on your behalf.
      <br />
      Replies are sent to your email inbox.
    </span>
  ),
  aiLanguageSelector: {
    tooltip: 'Change the AI generated message language',
    auto: 'Auto (based on candidate info)',
    english: 'English',
    dutch: 'Dutch',
  },
  jobboardRestrictionMessage: (days, platform) =>
    `Due to restrictions of ${platform} it is only possible to send a new message to this candidate in ${days} ${
      days === 1 ? 'day' : 'days'
    }.`,
  unavailableOnThisContactMethod: 'Unavailable',
  browserExtensionNotInstalled: 'Install our browser extension',
  needsLoginOnJobboard: 'Login on job platform',
  needsConnectMobileApp: 'Download and do login on Robin mobile app',
  notesModificationHistory: 'Notes modification history',
  lastEditedBy: 'Last edited by',
  seeFullHistory: 'See full history',
  emailCandidate: 'Email candidate',
  callCandidate: 'Call candidate',
  workingOnIt: 'Working on it...',
  call: 'Call',
  callMobileByPushNotification: 'Call via mobile app',
  searchNameOrOwnerOfTheSearch: 'Search name or owner (first name, last name, or email address)',
  candidateNoLongerAvailable: 'This candidate is no longer available',
  canceledByUser: 'Canceled by user',
  callingIsAutomaticDescription:
    'Calling is automatic when you have a VoIP system or your phone is connected to your computer',
  makeActive: 'Make active',
  makeInactive: 'Make inactive',
  filterBy: 'Filter by',
  lastContactedBy: ({ when }) => `This candidate was last contacted ${when} `,
  noTemplateAvailable: 'No template available',
  createNewSearch: 'Create new search',
  creatingNewSearch: 'Creating new search...',

  consumerKey: 'Consumer key',
  consumerSecret: 'Consumer secret',
  atsConnectedSuccessfully: (ats) => `${ats} connected successfully`,
  weAreConnectingToYourATS: 'We are connecting to your ATS...',
  atsCandidateStatusChanged: 'Candidate status changed',
  atsNoteAdded: 'Note added in ATS',
  atsEmailSent: 'Email sent',
  noCreditsAvailable: 'No credits available',
  selectAProject: 'Select a project',
  emailOrPhone: 'Email or phone',
  candidateSuccessfullyShortlistedToAnotherSearch: 'Candidate successfully shortlisted to another search',

  noCreditsAvailableForMonsterboardTitle: "You've run out of Monsterboard credits.",
  noCreditsAvailableForMonsterboardDescription: () => (
    <>
      Therefore, you no longer have access to Monsterboard candidate contact information. You can request new credits at{' '}
      <strong>support@recruitrobin.com</strong>. You will then receive a proposal from us. The proposal is free of
      charge and will be sent to the 'admin' of your Robin account.
    </>
  ),
  errorRetrievingDepartments: 'Error retrieving departments',
  noDepartmentsFound: 'No departments found, please check your RecruitNow dashboard',
  activateBeforeSearchDepartments: 'You must active this user before select a department',
  candidateAlreadyInteracted: 'This candidate was previously actioned upon',
  candidateAlreadyLinkedToAnotherMatch:
    "This candidate is already linked to another match. We've hidden this one for you.",
  newVersionAvailable: 'New version available',
  newVersionAvailableDescription: () => (
    <>
      <u>Click here</u> to reload the page with the new version
    </>
  ),
  indeedSessionOutdated: 'Indeed session outdated',
  indeedSessionOutdatedDescription: (onLinkClick?: () => void) => (
    <>
      Your Indeed session headers are outdated.{' '}
      <a href="https://employers.indeed.com/" target="_blank" rel="noreferrer" onClick={onLinkClick}>
        Visit Indeed
      </a>{' '}
      to refresh.
    </>
  ),
  continue: 'Continue',
  languageSelection: 'Language Selection',
  googleTranslateMessage: () => (
    <span>
      Using Google Chrome's automatic translation will render our program unusable. To ensure a working app, you will
      not be able to use our program until you disable it.{' '}
      <a href="https://help.recruitrobin.com/nl/articles/8286616-gekke-vertalingen" target="_blank" rel="noreferrer">
        Read how to do that here!
      </a>
    </span>
  ),
  maxAsteriskReached: "Sorry, you've exceeded the limit of 5 titles, including (*)",
  maxAsteriskReachedModalDescription:
    'In the field job titles or skills/keywords, a maximum of 5 asterisks (*) are allowed. Please edit your search query to proceed.',
  maxAsteriskReachedModalClickHere: ({ href }) => (
    <span>
      <a href={href} target="_blank" rel="noreferrer">
        Click here
      </a>{' '}
      for more information.
    </span>
  ),
  hideCandidatesThat: 'Hide candidates with status',
  forPeriodOf: 'For period of',
  aiSuggestions: 'AI suggestions',
  searchInputPlaceholder: 'e.g. Operator in Utrecht with MBO, Jan Bakker, 0612345678',
  findCandidates: 'Find candidates',
  lastSearches: 'Last searches',
  noSearchesFound: 'No searches found',
  didntFindJobTitleLocation: "Didn't find any job title or location. Please retry",
  robinYearWrapped: ({ year }) => `Robin ${year} wrapped`,
  robinWrapped: 'Robin wrapped',
  downloadYearWrapped: ({ year }) => `Download the ${year} wrapped`,
  wrappedYear: ({ year }) => `${year} wrapped`,
  wrappedSummary: ({ tenantName }) => `A comprehensive summary of "${tenantName}" activity`,
  matchedInYear: ({ year }) => `Matched in ${year}`,
  shortlistedInYear: ({ year }) => `Shortlisted in ${year}`,
  contactedInYear: ({ year }) => `Contacted in ${year}`,
  topJobboard: 'Top jobboard',
  mostActiveUser: 'Most active users',
  totalAction: 'Total actions',
  lengthLimitReached: 'Length limit reached',
  getConnectedInstantly: 'Get Connected Instantly!',
  downloadOurMobileApp: 'Download our mobile app',
  downloadOurMobileAppDescription: ' and enable notifications. This quick setup connects you directly with candidates',
  yourCallIsJustATapAway: 'Your call is just a tap away!',
  checkYourPhoneForADirectCall:
    "Check your phone for a 'Direct Call' notification and tap to contact with candidate instantly!",
  downloadRobinMobileApp: 'Download Robin app!',
  selectYourDevicePlatform: "Select your device's platform to download our app.",
  tapToCallCandidate: (candidateName) => `Tap to call "${candidateName}" now!`,
  youCanCopyTheLinkPressingCtrlC: 'You can copy the link by pressing Ctrl (Command) + C',
  info: 'Info',
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
  communicationChannelsWarning: 'Not all communication channels are connected, so you might miss important messages.',
  welcomeBack: 'Welcome back!',

  dashboard: 'Dashboard',
  summary: 'Summary',
  summaryOfActions: 'Summary of actions',
  addSummary: 'Add summary',
  removeSummary: 'Remove summary',
  allCampaigns: 'All campaigns',
  allUsers: 'All users',

  overviewOfActions: 'Overview of actions',
  onlyLastThreeMonths: 'only last 3 months',

  mostUsedJobboardsForMatched: (method: string) => `Most used job boards for ${method.toLowerCase()}`,
  leaderboard: 'Leaderboard',
  summaryOfActivityForUsers: 'Summary of activity for users / teams',
  allActions: 'All actions',
  campaignCreated: 'Campaign created',
  campaignListEmptyStateMessage:
    'Use the search bar above to start a new search and find the perfect candidates across multiple job boards',

  exportInPDF: 'Export in PDF',
  noMoreResults: 'No more results',
  usersSelected: 'users selected',
  campaignsSelected: 'campaigns selected',
  clickHereToLoginBackIn: 'To connect, click the button, and then login to your',
  loginSuccessfully: 'Login successfully',
  browserExtensionIsDisabledOrNotInstalled:
    'The browser extension is disabled or not installed. Check the status or reinstall via the button!',
  clickHereToRefreshThisPage: 'Click here to refresh this page',
  toDisconnectClickTheButton: 'To disconnect, click the button, and then log out from your',
  shouldInstallBrowserExtensionTitle: 'Robin extension',
  shouldInstallBrowserExtensionModal: (
    <span>
      You do not have our browser extension installed. To take advantage of hourly new candidates notifications and the
      ability to contact LinkedIn and Indeed candidates through Robin please install the extension.
      <br />
      You can install the extension by visiting{' '}
      <a
        href="https://chromewebstore.google.com/detail/recruit-robin/edfebfbdfncaeokbcjehncoelddchlhi?hl=nl"
        target="_blank"
        rel="noreferrer">
        this link
      </a>
    </span>
  ),
  shouldCallWerknlOutreachTitle: 'eHerkenning is not connected',
  shouldCallWerknlOutreachModal: (
    <span>
      Sending messages via werk.nl is not yet set up for your organisation. We need an authorization from your
      organisation to activate this feature. Ask your manager, contact us via{' '}
      <a href="mailto:support@recruitrobin.com">support@recruitrobin.com</a> or follow{' '}
      <a
        href="https://help.recruitrobin.com/nl/articles/9320876-robin-machtigen-voor-werk-nl-eherkenning"
        target="_blank"
        rel="noreferrer">
        these steps
      </a>{' '}
      to set up the authorization.
    </span>
  ),
  shouldCallWerknlOutreachDoesntSatisfyAuthorizationTitle: 'You do have an authorisation, but not the correct rights',
  shouldCallWerknlOutreachDoesntSatisfyAuthorizationModal: 'Adjust your rights in the eHerkenning settings.',
  shouldCallWerknlOutreachAuthorizationExpiredTitle: 'Your authorisation has expired',
  shouldCallWerknlOutreachAuthorizationExpiredModal: 'Renew your authorisation to continue.',
  linkedinRunOutCreditsMessage:
    "You've used all 5 of your free personalized invitations for this month. LinkedIn will reset next month. You can still send connection requests.",
  linkedinRunOutCreditsSendMessage: 'Send linkedIn connection request',
  linkedinRunOutCreditsSendingMessage: ({ onClick }) => {
    return (
      <span>
        Sorry, your message wasn't send
        <br />
        You where out of credits to send
        <br />
        messages on LinkedIn. You can still send
        <br />
        connection invites.{' '}
        <b onClick={onClick}>
          <u>Click here</u>
        </b>{' '}
        to send a<br />
        connection invite.
      </span>
    );
  },
  werknlMessageTo: (name) => `Werk.nl message to ${name}`,
  werknlInputEmail: 'Email (required if phone not provided)',
  werknlInputPhone: 'Phone (required if email not provided)',

  settings: 'Settings',
  emailSettings: 'Email settings',
  schedulerEditor: 'Scheduler Editor',
  connectEmailAccount: 'Connect your email',
  reconnectEmailAccount: 'Reconnect email account',
  disconnectEmailAccount: 'Disconnect email account',
  theConnectionWasASuccess: 'The connection was a success!',
  theConnectionWasASuccessDescription:
    'Your email account has been successfully connected to the Robin platform. You will now send your emails through Robin.',
  backToRobin: 'Back to Robin',
  emailConnectedDescription:
    'Your email account is connected to Robin. You can now send, receive, and track emails from our platform.',
  connectYourEmailToContinue: 'Connect your email to continue',
  shouldConnectEmailDialogDescription: (
    <>
      To contact candidates via email, you need to connect your Gmail or Outlook account. This allows Robin to track
      replies and provide insights on your outreach performance.
      <ul>
        <li>
          Having trouble connecting your email? Contact{' '}
          <a href="mailto:support@recruitrobin.com">support@recruitrobin.com</a>
        </li>
      </ul>
    </>
  ),
  emailConnected: 'Email connected',
  yourEmailIsConnectedAndReadyToUse: 'Your email is connected and ready to use',
  ok: 'Ok',
  verifyingConnection: 'Verifying connection',
  verifyConnection: 'Verify connection',
  tryAgain: 'Try again',
  pleaseWaitWhileWeVerifyYourEmailConnection: 'Please wait while we verify your email connection',
  errorWhileConnectingEmail: 'Error while connecting email',
  errorWhileConnectingEmailDescription:
    'There was an error connecting your email. Please try again or verify your existing connection.',
  emailCopiedCandidateMarkedAsContacted: 'Email copied. Candidate marked as contacted',
  emailNotConnectedDescription: (
    <span>
      Connect your company email to Robin to increase conversion on messages.{' '}
      <a href="https://help.recruitrobin.com/en/articles/9414745-email" target="_blank" rel="noreferrer">
        Learn more
      </a>
    </span>
  ),

  emailConnections: 'Connected emails',
  disconnectEmailAccountModalDescription:
    'Are you sure you want to disconnect your email account from the Robin platform? If you proceed, you will no longer be able to send emails through Robin.',
  connectEmailModalDescription:
    'Connect your personal or company email accounts to Robin to send emails from our platform.',
  theConnectionFailed: 'Connection unsuccessful!',
  theConnectionFailedDescription:
    'Please ensure that the email you are connecting is the same as the one you use to login to Robin.',
  connectEmailDescription: (
    <span>
      To improve conversion on emails send we encourage everyone to connect their business email to Robin.{' '}
      <a href="https://help.recruitrobin.com/en/articles/9414745-email" target="_blank" rel="noreferrer">
        Learn more
      </a>
    </span>
  ),
  remindToConnectEmail: (name) => (
    <span>
      Hi {name},
      <br />
      <br />
      To provide you the following benefits, we're changing our email server;
      <br />
      <br />
      <div css={{ paddingLeft: '1em' }}>
        1. <strong>More candidates that respond to your email</strong>. You can now use your own email server to send
        emails instead of ours. This will reduce the number of emails that go into spam.
      </div>
      <br />
      <div css={{ paddingLeft: '1em' }}>
        2. <strong>Find sent emails in your mailbox</strong>. Every email you send will now be shown in your 'sent'
        mailbox of your own email account. That's how you can be sure that every email is sent correctly. As a bonus,
        you'll automatically collect all email communication in your own mailbox.
      </div>
      <br />
      <strong>Need help?</strong>
      <br />
      Ask us for help using the chat and we'll connect it together!
    </span>
  ),
  remindToReconnectEmail: (name) => (
    <span>
      Hi {name},
      <br />
      <br />
      Due to a technical issue, we need to reconnect your email account.
      <br />
      This is required to ensure you can continue using the email integration to send emails to candidates.
      <br />
      <br />
      Just click on the "Reconnect email" button below, and we will take you through the flow in just a minute!
    </span>
  ),
  werknlProfiles: 'Werknl Profiles',
  waitForTheCampaignToFullyLoad: 'Please wait for the search to be fully loaded',
  werknlIsCurrentlyDisabled: 'Werk.nl is currently disabled',
  loadingCandidateCv: 'Loading candidate CV',
  noShortlistedCandidate: ({ onClick }) => {
    return (
      <span>
        You haven't shortlisted any candidates yet! Start by shortlisting the best candidates from your{' '}
        <u onClick={onClick} css={{ cursor: 'pointer' }}>
          search results.
        </u>
      </span>
    );
  },
  noOtherStatusCandidate: (status) => `You haven't ${status} any candidates yet!`,
  werknlCandidateInfoPresentation: (
    <span>
      Which{' '}
      <a href={'https://www.werk.nl/werkzoekenden/'} target="_blank" rel="noreferrer">
        Werk.nl
      </a>{' '}
      profile do you prefer?
    </span>
  ),
  werknlCandidateInfoPresentationDescription:
    'We have changed the candidate profile layout to make it easier to assess candidates. Which version do you want to continue using?',
  werknlCandidateInfoPresentationNote: '*The choice can still be changed later in your personal profile settings',
  old: 'Old',
  confirmSelection: 'Confirm selection',
  werknlLayout: 'Werk.nl layout',
  cvFormatIssues: 'This CV cannot be displayed due to formatting issues.',
  disconnectVacancy: 'Disconnect from ATS',
  clickToActivatePlatform: (platform) => `Click to activate ${platform}`,
  fromTo: (from, to) => `from ${from} to ${to}`,
  from: 'from',
  newCandidateAdded: 'New candidate added',
  for: 'for',
  called: 'Called',
  confirmDeleteNote: 'Are you sure you want to delete this note?',
  robinResume: 'Robin Resume',
  robinResumeDescription: (atsName) => (
    <span>
      Toggle to activate or deactivate syncing with {atsName ? <strong>{capitalize(atsName)}</strong> : 'your ATS'}.
    </span>
  ),
  confirmStatus: 'Confirm status',
  statusSavedWithSuccess: 'Statuses saved with success',
  syncingYourAtsStatuses: 'Syncing your ATS statuses. Please wait...',
  statusConfirmed: 'Status confirmed',
  statusesRefreshed: 'Statuses refreshed',
  checkCandidateStatuses: 'Check candidate statuses',
  statusNeedToBeConfirmedForThisTenant: 'The status need to be confirmed for this tenant.',
  readMore: 'Read more',
  loginToIndeed: 'Login to Indeed',
  indeedAssignedMessageInfo: (email) => (
    <span>
      The Indeed Smart Sourcing subscription <strong>{email}</strong> is now assigned to your Robin-account. Log in to
      Indeed with this email to start contacting Indeed candidates with Robin.
    </span>
  ),
  indeedUnassignedMessageInfo: (
    <span>
      No Indeed Smart Sourcing subscription has been assigned to your Robin account. Please contact{' '}
      <strong>your organization's Robin administrator</strong> to request one. Read{' '}
      <a href={DICTIONARY_LINKS.INDEED_KNOW_MORE} target="_blank" rel="noreferrer" className="no-visited-style">
        this article
      </a>{' '}
      for more information.
    </span>
  ),
  indeedLicenseRequired: (
    <span>
      Indeed license required
      <br />
      Click to read more
    </span>
  ),
  indeedLicense: 'Indeed license',
  isAdmin: 'Is admin',
  indeedLicensesCanBeAssigned: 'Subscriptions can be assigned up to 1 time per month to another user.',
  indeedSubscriptionConnectedTitle: 'Indeed subscription connected',
  indeedSubscriptionConnectedDescription: (email) => (
    <span>
      To access Indeed CVs in Robin, you will need an Indeed Smart Sourcing subscription from January 1st, 2025. We have
      linked the Indeed Smart Sourcing subscription <strong>{email}</strong> to your account in Robin.
      <br />
      <br />
      <strong>What you need to know</strong>
      <ul>
        <li>You can now easily find and access Indeed resumes with Robin.</li>
        <li>One Indeed Smart Sourcing subscription can be linked to one Robin user.</li>
        <li>An Indeed Smart Sourcing subscription can be assigned to a colleague once per month.</li>
      </ul>
      <strong>Want to know more?</strong>
      <br />
      For answers to questions, click on 'Read more'.
    </span>
  ),
  noIndeedSubscriptionConnectedTitle: 'No Indeed-account connected',
  noIndeedSubscriptionConnectedDescription: (
    <span>
      There is currently no Indeed-account linked to your Robin-account. To access Indeed CVs in Robin, you need to
      connect an Indeed-account with an active Indeed Smart Sourcing subscription from January 1st, 2025.
      <br />
      <br />
      <strong>Connect Indeed-account</strong>
      <ul>
        <li>
          <strong>Log in to Indeed: </strong>Make sure the{' '}
          <a href={DICTIONARY_LINKS.ROBIN_EXTENSION} target="_blank" rel="noreferrer" className="no-visited-style">
            Robin extension
          </a>{' '}
          is active and log in to your Indeed- account.
        </li>
        <li>
          <strong>Link Indeed: </strong>Robin automatically links an active Indeed Smart Sourcing subscription to your
          Robin-account, unless there is no active Smart Sourcing subscription or it is already linked to a colleague's
          Robin-account.
        </li>
        <li>
          <strong>Use existing subscription: </strong>
          <a
            href={DICTIONARY_LINKS.EXISTING_SUBSCRIPTION}
            target="_blank"
            rel="noreferrer"
            className="no-visited-style">
            read here
          </a>{' '}
          how to link a Smart Sourcing subscription to your Robin-account, if it is currently in use by a colleague.
        </li>
        <li>
          <strong>Buy subscription: </strong>
          <a href={DICTIONARY_LINKS.BUY_NEW_SUBSCRIPTION} target="_blank" rel="noreferrer" className="no-visited-style">
            click here
          </a>{' '}
          if you want to buy an(other) Indeed Smart Sourcing subscription.
        </li>
      </ul>
      <strong>Want to know more?</strong>
      <br />
      <a href={DICTIONARY_LINKS.INDEED_KNOW_MORE} target="_blank" rel="noreferrer" className="no-visited-style">
        Click here
      </a>{' '}
      for answers to questions and more information about this term.
    </span>
  ),
  indeedSubscriptionAvailableTitle: 'Indeed subscription available',
  indeedSubscriptionAvailableDescription: (emails) => (
    <span>
      To access Indeed CVs in Robin, you will need an Indeed-account with Smart Sourcing subscription as of January 1st,
      2025. There are Indeed-account(s) with an Indeed Smart Sourcing subscription available for you to connect.
      <br />
      <br />
      <strong>Connect Indeed subscription</strong>
      <ul>
        <li>
          <strong>Log in to Indeed: </strong>Make sure the Robin extension is active and log in to (one of these)
          Indeed-account(s);
          <ul>
            {emails.map((email, i) => (
              <li key={i}>{email}</li>
            ))}
          </ul>
        </li>
        <li>
          <strong>Connect Indeed: </strong>Robin automatically connects an active Indeed Smart Sourcing subscription to
          your Robin-account.
        </li>
      </ul>
      <strong>Want to know more?</strong>
      <br />
      <a href={DICTIONARY_LINKS.INDEED_KNOW_MORE} target="_blank" rel="noreferrer" className="no-visited-style">
        Click here
      </a>{' '}
      for answers to questions and more information about this term.
    </span>
  ),
  noIndeedSubscriptionAvailableTitle: 'No Indeed subscription available',
  noIndeedSubscriptionAvailableDescription: (
    <span>
      To access Indeed CVs in Robin, you will need an Indeed Smart Sourcing subscription from January 1st, 2025. At the
      moment, all Indeed-account(s) with a Smart Sourcing subscription are in use by colleagues.
      <br />
      <br />
      <strong>Connect Indeed subscription</strong>
      <ul>
        <li>
          <strong>Request access </strong>from colleagues with 'admin' rights in Robin. They can link an Indeed Smart
          Sourcing subscription to your account. An Indeed Smart Sourcing subscription can be assigned to another
          colleague once a month.
        </li>
        <li>
          <strong>Additional subscription: </strong>
          <a href={DICTIONARY_LINKS.BUY_NEW_SUBSCRIPTION} target="_blank" rel="noreferrer" className="no-visited-style">
            click here
          </a>{' '}
          if you want to purchase an Indeed Smart Sourcing subscription for your Indeed-account.
        </li>
      </ul>
      <strong>Want to know more?</strong>
      <br />
      Click on 'read more' for answers to questions and more information about this term.
    </span>
  ),
  indeedSubscriptionGrantedTitle: 'Indeed subscription granted',
  indeedSubscriptionGrantedDescription: (email) => (
    <span>
      A colleague has assigned the Indeed Smart Sourcing subscription <strong>{email}</strong> to your account in Robin.
      You can now easily find and access Indeed CVs with Robin.
      <br />
      <br />
      <strong>Connect Indeed subscription</strong>
      <ul>
        <li>Log in to Indeed with the account {email}.</li>
        <li>Robin automatically connects the Indeed Smart Sourcing subscription to your Robin-account.</li>
      </ul>
    </span>
  ),
  indeedSubscriptionWithdrawnTitle: 'Indeed subscription withdrawn',
  indeedSubscriptionWithdrawnDescription: (email) => (
    <span>
      You no longer have access to Indeed CVs via Robin. A colleague has cancelled the Indeed Smart Sourcing
      subscription <strong>{email}</strong> or assigned it to another colleague. There are currently no other
      Indeed-accounts available with Indeed Smart Sourcing subscriptions.
      <br />
      <br />
      <strong>Connect Indeed subscription</strong>
      <ul>
        <li>
          <strong>Request access </strong>from colleagues with 'admin' rights in Robin. They can connect an Indeed Smart
          Sourcing subscription to your account. An Indeed Smart Sourcing subscription can be assigned to another
          colleague once a month.
        </li>
        <li>
          <strong>Additional subscription: </strong>Click here if you want to purchase an additional Indeed Smart
          Sourcing subscription.
        </li>
      </ul>
      <strong>Want to know more?</strong>
      <br />
      Click on 'read more' for answers to questions.
    </span>
  ),
  indeedSubscriptionWithdrawnSubscriptionAvailableTitle: 'Indeed subscription withdrawn',
  indeedSubscriptionWithdrawnSubscriptionAvailableDescription: (email, emails) => (
    <span>
      You no longer have access to Indeed CVs via Robin. A colleague has cancelled or assigned the Indeed Smart Sourcing
      subscription <strong>{email}</strong> to another colleague. There are other Indeed-accounts with Smart Sourcing
      subscription(s) available for your Robin-account.
      <br />
      <br />
      <strong>Connect Indeed subscription</strong>
      <ul>
        <li>
          <strong>Log in to Indeed: </strong>Make sure the Robin extension is active and log in to (one of these)
          Indeed-account(s);
          <ul>
            {emails.map((email, i) => (
              <li key={i}>{email}</li>
            ))}
          </ul>
        </li>
        <li>
          <strong>Connect Indeed: </strong>Robin automatically connects an active Indeed Smart Sourcing subscription to
          your Robin-account.
        </li>
      </ul>
      <strong>Want to know more?</strong>
      <br />
      <a href={DICTIONARY_LINKS.INDEED_KNOW_MORE} target="_blank" rel="noreferrer" className="no-visited-style">
        Click here
      </a>{' '}
      for answers to questions.
    </span>
  ),
  indeedSubscriptionExpiredWithAvailableTitle: 'Indeed subscription expired',
  indeedSubscriptionExpiredWithAvailableDescription: (emails) => (
    <span>
      The Indeed-account you tried to log in with does not have an active Smart Sourcing subscription. To access all
      Indeed CVs through Robin, you'll need an Indeed-account with an active Indeed Smart Sourcing subscription.
      <br />
      <br />
      <strong>Connect Indeed subscription</strong>
      <ul>
        <li>
          <strong>Log in to an Indeed-account </strong>with an active Smart Sourcing subscription:
          <ul>
            {emails.map((email, i) => (
              <li key={i}>{email}</li>
            ))}
          </ul>
        </li>
        <li>
          <strong>Connect to Indeed: </strong>Robin automatically connects an active Indeed Smart Sourcing subscription
          to your Robin-account, once you are logged in to Indeed.
        </li>
      </ul>
    </span>
  ),
  indeedSubscriptionExpiredTitle: 'Indeed subscription expired',
  indeedSubscriptionExpiredDescription: (
    <span>
      The Indeed-account you tried to log in with does not have an active Smart Sourcing subscription. To access all
      Indeed candidates through Robin, you'll need an Indeed-account with an active Indeed Smart Sourcing subscription.
      <br />
      <br />
      <strong>Connect Indeed subscription</strong>
      <ul>
        <li>
          <strong>Use existing subscription: </strong>request access from colleagues with 'admin' rights in Robin to
          connect another Indeed Smart Sourcing subscription to your Robin-account, if available. Login to Indeed with
          the e-mail address connected to the Indeed Smart Sourcing subscription.
        </li>
        <li>
          <strong>Buy subscription: </strong>
          <a href={DICTIONARY_LINKS.BUY_NEW_SUBSCRIPTION} target="_blank" rel="noreferrer" className="no-visited-style">
            click here
          </a>{' '}
          if you want to buy an Indeed Smart Sourcing subscription for your current Indeed-account.
        </li>
      </ul>
      <strong>Want to know more?</strong>
      <br />
      For answers to questions, click on 'Read more'.
    </span>
  ),
  indeedSubscriptionConnectedAdminTitle: 'Indeed subscription assigned',
  indeedSubscriptionConnectedAdminDescription: (email) => (
    <span>
      To access Indeed CVs in Robin, you will need an Indeed Smart Sourcing subscription from January 1st, 2025. We have
      connected the Indeed Smart Sourcing subscription <strong>{email}</strong> with your account in Robin.
      <br />
      <br />
      <strong>Assign Indeed subscriptions</strong>
      <br />
      As an admin of Robin, you can assign Indeed Smart Sourcing subscriptions to your own Robin-account and that of
      your colleagues.
      <br />
      <br />
      <ul>
        <li>You can assign Smart Sourcing subscription(s) to colleagues in the main menu under 'users'.</li>
        <li>One Indeed Smart Sourcing subscription can be connected with one Robin-account.</li>
        <li>An Indeed Smart Sourcing subscription can be assigned to a different colleague once a month.</li>
      </ul>
      <strong>Want to know more?</strong>
      <br />
      For answers to questions, click on 'Read more'.
    </span>
  ),
  noIndeedSubscriptionConnectedAdminTitle: 'No Indeed subscription(s) assigned',
  noIndeedSubscriptionConnectedAdminDescription: (
    <span>
      There is currently no Indeed Smart Sourcing subscription linked to your Robin-account, or that of colleagues. To
      access Indeed CVs in Robin, you will need an Indeed Smart Sourcing subscription from January 1st, 2025.
      <br />
      <br />
      <strong>Assign Indeed subscriptions</strong>
      <br />
      As an admin of Robin, you can assign Indeed Smart Sourcing subscriptions to your own Robin-account and that of
      your colleagues.
      <br />
      <br />
      <ul>
        <li>
          <strong>Log in to Indeed: </strong>Make sure the Robin extension is active and log in to your Indeed- account.
        </li>
        <li>
          <strong>Link Indeed: </strong>Robin automatically links an active Indeed Smart Sourcing subscription to your
          Robin-account, unless it is already linked to a colleague's account.
        </li>
        <li>
          <strong>Assign subscription(s) to colleagues: </strong>You can do this in the main menu under 'users'.
        </li>
      </ul>
      <strong>Want to know more?</strong>
      <br />
      <a href={DICTIONARY_LINKS.INDEED_KNOW_MORE} target="_blank" rel="noreferrer" className="no-visited-style">
        Click here
      </a>{' '}
      for answers to questions and more information about this term.
    </span>
  ),
  noIndeedActiveSubscriptionWithAvailableTitle: 'No active Indeed subscription',
  noIndeedActiveSubscriptionWithAvailableDescription: (email, emails) => (
    <span>
      There is no active Indeed Smart Sourcing subscription linked to your Indeed-account <strong>{email}</strong>. To
      access all Indeed CVs through Robin, you'll need an Indeed-account with an active Indeed Smart Sourcing
      subscription, from January 1st, 2025.
      <br />
      <br />
      <strong>Connect Indeed subscription</strong>
      <ul>
        <li>
          <strong>Login to </strong>an Indeed-account with an active Smart Sourcing subscription:
          <ul>
            {emails.map((email, i) => (
              <li key={i}>{email}</li>
            ))}
          </ul>
        </li>
        <li>
          <strong>Connect to Indeed: </strong>Robin automatically connects an active Indeed Smart Sourcing subscription
          to your Robin-account, once you are logged in to Indeed.
        </li>
      </ul>
    </span>
  ),
  noIndeedActiveSubscriptionTitle: 'No active Indeed subscription',
  noIndeedActiveSubscriptionDescription: (email) => (
    <span>
      There is no active Indeed Smart Sourcing subscription linked to your Indeed-account <strong>{email}</strong>. To
      access all Indeed CVs through Robin, you'll need an Indeed-account with an active Indeed Smart Sourcing
      subscription, from January 1st, 2025.
      <br />
      <br />
      <strong>Connect Indeed subscription</strong>
      <ul>
        <li>
          <strong>Using another Indeed-account: </strong>Does your organization already have a subscription that is
          linked to another Indeed-account?{' '}
          <a
            href={DICTIONARY_LINKS.EXISTING_SUBSCRIPTION}
            target="_blank"
            rel="noreferrer"
            className="no-visited-style">
            Read here
          </a>{' '}
          how you can link another Indeed-account to your Robin-account, and what you can do if it is currently in use
          by a colleague.
        </li>
        <li>
          <strong>Buy subscription: </strong>
          <a href={DICTIONARY_LINKS.BUY_NEW_SUBSCRIPTION} target="_blank" rel="noreferrer" className="no-visited-style">
            click here
          </a>{' '}
          if you do not yet have an Indeed subscription and want to buy one.
        </li>
      </ul>
    </span>
  ),
  unassignLicense: 'Unassign license',
  robinResumeDashboardDescription:
    'The number of resumes you have shared and the actions done by recruiters with your resumes.',
  totalNumberOfCvs: 'Total number of CVs',
  startsWith: 'Starts with',
  contains: 'Contains',
  endsWith: 'Ends with',
  selectAnAtsVacancy: 'Select an ATS vacancy',
  selectJobImprovedModalSubtitle: 'Choose a vacancy to push the candidate to your ATS.',
  selectJobModalInsufficientJobInfo:
    "This job doesn't have enough information for Robin Jr. to get started. You can improve the job description or select another job to continue.",
  selectJobModalIntroMessage: (
    <>
      To use Robin Jr. and automate your first reach-out and follow-up, you need to first select a job. This helps
      tailor communications effectively.
      <br />
      <br />
      Please select an existing job or create a new one to continue:
    </>
  ),
  selectAtsVacancyFirst: (candidateFirstName: string, atsName: string) => `Add ${candidateFirstName} to ${atsName}`,
  selectAtsVacancyRobinJr: (candidateFirstName: string, atsName: string) =>
    `Pick a job in ${atsName}. When ${candidateFirstName} responds positively, we'll add them automatically to ${atsName}.`,
  selectAtsVacancyForMatching: (candidateFirstName: string, atsName: string) =>
    `Pick a job from ${atsName}. When ${candidateFirstName} moved to match, we'll add them automatically to ${atsName}.`,
  skipAndMatch: 'Skip & match',
  matchAndPushToAts: 'Match & push to ATS',
  skipAndSendMessage: 'Skip & send message',
  sendAndPushToAts: 'Send & push to ATS',
  selectAtsVacancyForScheduling: (candidateFirstName: string, atsName: string) =>
    `Pick a job in ${atsName}. When you schedule an interview for ${candidateFirstName}, we'll sync it with ${atsName}.`,
  skipAndSchedule: 'Skip & open scheduler',
  connectAndSchedule: 'Connect & open scheduler',
  theCandidate: 'the candidate',
  yourAts: 'your ATS',
  insufficientInfoRobinJr:
    'Insufficient info in the selected vacancy. Please update the vacancy in your ATS or select another one to get help from Robin Jr.',
  enabledRobinJrFollowUpTitle: 'Automatic follow-up',
  enabledRobinJrFollowUpDescription:
    'We send the candidate up to two follow-up messages to boost your chances of a reply. The first one goes out after two days.',
  disableRobinJrFollowUpTitle: 'Cancel the follow-up?',
  disableRobinJrFollowUpDescription:
    "If you cancel this follow-up, it won't be rescheduled automatically, and you'll need to follow up manually.",
  yesCancelIt: 'Yes, cancel it',
  candidateContactedViaEmail: 'This candidate was previously contacted via email.',
  read: 'Read',
  emailFollowUpPlanned: 'Email follow-up planned',
  cancelFollowUp: 'Cancel follow-up',
  robinJr: 'Robin Jr.',
  boostReplies: 'Add a job and let AI boost responses by 70%',
  letsTryIt: 'Lets try it!',
  reachoutConversion: 'Reach-out conversion',
  conversionOfAllChannels: 'Conversion of all AI reach-out channels',
  conversations: 'Conversations',
  conversion: 'Conversion',
  weAreGeneratingAiMessage: 'We are writing a customized message, based on the CV and your vacancy.',
  candidatesContacted: 'Contacted',
  responded: 'Responded',
  replied: 'Replied',
  manualReachOut: 'Manual reach-out',
  aiReachOut: 'AI reach-out',
  matchedByColleague: 'Matched by me or colleague',
  contactedByColleague: 'Contacted by me or colleague',
  hiddenByMe: 'Hidden by me',
  createNewJob: 'Create new job',
  addJob: 'Add job',
  editCustomJob: 'Edit custom job',
  disconnectJob: 'Disconnect job',
  callOutcome: 'Call outcome',
  selectLabel: 'Select a label',
  theLabelSelectionIsRequired: 'The label selection is required',

  // Central Inbox
  inbox: 'Inbox',
  emptyConversations: 'Your inbox is empty!',
  addNote: 'Add note',
  takeNote: 'Take note',
  all: 'All',
  unread: 'Unread',
  sent: 'Sent',
  openInInbox: 'Open in inbox',
  switchAnyway: 'Switch Anyway',
  stayOnCurrentChannel: 'Stay on Current Channel',
  switchChannelsTitle: 'Switching Channels Will Discard Your Input',
  switchChannelsContent:
    "The input you've entered will not be saved if you switch to a different channel. Are you sure you want to proceed?",
  inboxEmailConnected: 'Email channel is connected',
  inboxEmailDisconnected: 'Click to connect Email channel',
  inboxWhatsappConnected: 'The WhatsApp channel for sending messages is active.',
  inboxWhatsappDisconnected: 'Whatsapp channel is disconnected',
  inboxLinkedinConnected: 'Linkedin channel is connected',
  inboxLinkedinDisconnected: 'Click to connect Linkedin channel',
  inboxLinkedinInmailConnected: 'Linkedin inmail channel is connected',
  inboxLinkedinInmailDisconnected: 'Click to connect Linkedin inmail channel',
  inboxIndeedConnected: 'Indeed channel is connected',
  inboxIndeedDisconnected: 'Click to connect indeed channel',
  inboxRjCommunicationHubConnected: 'RJ Communication Hub is connected',
  inboxRjCommunicationHubDisconnected: 'RJ Communication Hub not connected',

  //job creation/enriching
  removeEnrichedVersion: 'Remove Enriched Version',
  atsDisconnected: 'ATS disconnected',
  atsNotConnected: 'ATS not connected',
  atsNotConnectedDescription: (
    <span>
      We're unable to display jobs from your Applicant Tracking System (ATS) because it hasn't been connected yet.{' '}
      <a href="https://help.recruitrobin.com/en/" target="_blank" rel="noopener noreferrer">
        Click here
      </a>{' '}
      to connect your ATS.
    </span>
  ),
  checkInfo: 'Check info',
  atsVersion: 'ATS Job',
  manageYourJobs: 'Manage your jobs',
  enrichedVersion: 'Enriched Version',
  jobPreview: 'Job preview',
  jobDetails: 'Job Details',
  viewOnIndeed: 'View on Indeed',
  updatingJobPreview: 'Updating based on your last changes...',
  visibleToCandidatesAsAttachment: 'Visible to candidates if included as an attachment.',
  theJobPreviewHasBeenCopied: 'The job preview has been copied',
  applicationDeadline: 'Application Deadline',
  salaryUnit: 'Salary Unit',
  workingHoursRange: 'Working Hours',
  workdays: 'Workdays',
  shifts: 'Shifts',
  workAddress: 'Work address',
  jobRequirements: 'Job requirements',
  minimumEducationLevel: 'Min. education Level',
  driversLicense: "Driver's License",
  secondaryBenefits: 'Secundary benefits',
  tasks: 'Tasks',
  keyTasks: 'Key tasks',
  employmentRequirements: 'Employment requirements',
  createAJob: 'Create a Job',
  enrichVacancyChooseMethod: 'Choose one of the following ways to get started:',
  provideText: 'Provide text',
  radiusKm: 'Radius (km)',
  positionOverview: 'Position Overview',
  languagesLabel: 'Languages',
  level: 'Level',
  fullTime: 'Full-time',
  partTime: 'Part-time',
  reviewingYourVacancyForQuality: 'Reviewing your job for quality...',
  editVacancy: 'Edit job',
  enrichVacancy: 'Enrich job',
  selectTemplate: 'Select template',
  uploadFile: 'Upload file (PDF or Word)',
  copyText: 'Copy text',
  copy: 'Copy',
  saveJobRequiredFields: 'You can only save this job once all required fields are filled in',
  searchVacancy: 'Search job',
  thisFieldIsRequiredError: 'This field is required',
  pleaseSelectAValidLocation: 'Please select a location from the suggestions',
  addDetailsOrSelectAnotherJob: 'Add details or select another job.',
  insufficientInfo: 'Insufficient Info',
  lowReplyChance: 'Low Reply Chance',
  mediumReplyChance: 'Medium Reply Chance',
  highReplyChance: 'High Reply Chance',
  sufficientInfo: 'Sufficient Info',
  letsImproveIt: "Let's Improve It",
  atsContentWarning: 'You can update "ATS Version" only in your ATS.',
  removeEnrichedVersionDescription:
    "If you remove the enriched version of this job, you'll still be able to view the original (ATS) version. This action cannot be undone.",
  yesRemoveIt: 'Yes, remove it',
  lowQuality: 'Low Quality',
  mediumQuality: 'Medium Quality',
  highQuality: 'High Quality',
  noVacanciesFound: 'No Jobs Found',
  checkYourAtsConnection: 'Please check your ATS connection',
  learnMore: 'Learn more',
  learnMoreLink: 'https://help.recruitrobin.com/en/',
  youCanAlso: 'You can also',
  inRobin: 'in Robin',
  theAtsContentHasBeenCopied: 'The ATS content has been copied',
  theIndeedContentHasBeenCopied: 'The Indeed content has been copied',
  errorProcessingVacancyFile: (
    <span>
      We couldn't read the selected file. <br />
      Make sure it's a valid PDF or Word document and try again.
    </span>
  ),
  addDetailsAndIncreaseYourChanceToGetAReply: (
    <span>
      Add details and increase your
      <br />
      chance to get a reply.
    </span>
  ),
  jobDescriptionComplete: (
    <span>
      The job description is complete.
      <br />
      Well done!
    </span>
  ),
  goodStatus: 'Good',
  hourly: 'hourly',
  monthly: 'monthly',
  weekly: 'weekly',
  yearly: 'yearly',
  allWorkDays: 'All workdays',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  shiftDay: 'Day shift',
  shiftEvening: 'Evening shift',
  shiftNight: 'Night shift',
  shift2Cycle: '2-cycle shift',
  shift3Cycle: '3-cycle shift',
  shift4Cycle: '4-cycle shift',
  shift5Cycle: '5-cycle shift',
  thinking: 'Thinking...',
  improveWithAI: 'Improve with AI',

  // vacancy creation/enriching placeholders form
  minimumEducationLevelPlaceholder: 'e.g. MBO',
  languagesPlaceholder: 'e.g. English, Dutch',
  address: 'Address',
  workAddressPlaceholder: 'e.g. 3526 KS, Utrecht or Utrecht and Eindhoven',
  phonePlaceholder: 'e.g. +31 0645536273',
  salaryRangePlaceholder: 'e.g. €3,000',
  salaryRangePlaceholderMax: 'e.g. €4,000',
  workingHoursRangePlaceholder: 'e.g. 40 - 50 hours',
  shiftPlaceholder: 'e.g. Day shift',
  workdaysPlaceholder: 'e.g. Monday - Friday',
  certificationsPlaceholder: 'e.g. Heftruckcertificaat',

  commuteByCar: 'Commute by car',
  commyteByBike: 'Commute by bike',
  bestMatch: 'Best matched',

  checkYourPhone: 'Check your phone',
  phoneNotConnected: 'Phone not connected',
  connectYourMobileToRobin: 'Connect your mobile to Robin',
  connectYourMobileToRobinDescription: (
    <span>
      Just follow these steps:
      <ul>
        <li>Download the Robin app (Recruit Robin) from your Apple store / Google play.</li>
        <li>Log in with your Robin details.</li>
        <li>Refresh this page. Done! Your phone is connected.</li>
      </ul>
      Need help? Email{' '}
      <a href="mailto:support@recruitrobin.com" target="_blank" rel="noopener noreferrer" className="default-link">
        support@recruitrobin.com
      </a>{' '}
      or start a chat.
    </span>
  ),
  messageTranslatedSuccessfully: 'Message translated successfully',
  gotIt: 'Got it!',
  default: 'Default',
  translatingMessage: 'Translating message...',
  selectTheLanguageOfTheMessage: 'Select the language of the message',
  moreJobDetailsNeeded: 'More job details needed to generate message',
  improveGeneratedMessage: 'Improve generated message',
  couldNotCreateMessageDueToInsufficientData:
    "We couldn't create the message because the ATS job you selected doesn't have enough data. Ready to improve it now?",
  messageGeneratedButCouldBeStronger:
    'We generated a message, but additional details could make it stronger. Would you like to improve it?',
  errorProcessingVacancy: "We couldn't process the vacancy data",
  errorProcessingAtsVacancy:
    "We couldn't process the vacancy data from the ATS.\nPlease check the original source or fill in the details manually.",
  youCannotImproveAlreadyImprovedVacancy: 'You cannot improve an already improved vacancy',
  /* ---- start: added by AI ---- */
  failedToProcessAtsVacancyMissing: ({ missingFields }: { missingFields: string }) =>
    `Failed to process ATS vacancy. Missing: ${missingFields}.`,
  /* ---- end: added by AI ---- */
  alwaysShowAlternativeChannels: 'Always show alternative channels',
  alternativeChannels: 'Alternative Channels',
  alternativeChannelsDescription: 'Would you like to try another way to reach out?',
  dontShowThisNextTime: "Don't show this next time",
  sendWhatsApp: 'Send WhatsApp',
  sendWerknl: 'Send werk.nl',
  sendLinkedin: 'Send LinkedIn',
  sendIndeed: 'Send Indeed',
  connectWithCandidateLinkedin: (candidateName) => `Connect with ${candidateName} on LinkedIn`,
  messageCandidateLinkedin: (candidateName) => `Message ${candidateName} on LinkedIn`,
  indeedJob: 'Indeed job',
  indeedJobs: 'Indeed jobs',
  atsJobs: 'ATS jobs',

  processing: 'Processing...',
  processJob: 'Process job',
  minWorkingHours: 'Min working hours',
  maxWorkingHours: 'Max working hours',
  minWorkingHoursPlaceholder: 'e.g. 40',
  maxWorkingHoursPlaceholder: 'e.g. 50',
  employmentTypeTemporaryAgencyWork: 'Temporary agency work',
  activateRobinJrTitle: 'Activate Robin Jr.',
  activateRobinJrDescription: (
    <>
      We&apos;ll customise messages using your job description and show it to candidates to improve reply rates
      <br />
      <br />
      Please confirm this is the correct job before starting
    </>
  ),
  activateRobinJrIndeedDescription: (
    <>
      We&apos;ll customise messages using your job description and show it to candidates to improve reply rates.
      <br />
      Please confirm this is the correct job and indeed project before starting:
    </>
  ),
  activateRobinJrTrackProgress: 'Track progress in the Activity tab and get email updates',
  getStarted: 'Get started',
  robinJrIsAnalysingYourVacancy: 'Robin Jr. is analysing your vacancy',
  startingRobinJr: 'Starting Robin Jr...',
  confirmAndStart: 'Confirm and start',
  confirmAndNext: 'Confirm and next',
  sendIndeedMessage: 'Send Indeed message',
  indeedCreditsRemainingPrefix: 'You have',
  indeedCreditsLabel: (credits) => `${credits} CREDITS`,
  indeedCreditsRemainingSuffix: 'remaining in your Indeed account.',
  indeedJobNotHighQuality: 'This job is not high quality.',
  editAndEnhanceJob: 'Edit and enhance it',
  toActivateRobinJr: 'to activate Robin Jr.',
  reviewQualificationQuestionary: 'Selection questions',
  loadingQualificationQuestionary: (
    <>
      We are creating screening questions
      <br />
      this only takes a few seconds
    </>
  ),
  pleaseReviewTheQualificationQuestions: "Mark for each question if it's a must or nice-to-have",
  jobUpdatedReviewRequired: (
    <>
      <b>Job updated! </b>
    </>
  ),
  autoSendInterviewInviteTitle: 'Auto-Send Interview Invite',
  autoSendInterviewInvite: (
    <>
      Automatically send an interview invite to candidates who <strong>meet all the required criteria.</strong>
    </>
  ),
  dontShowQualificationQuestionaryPreviewNextTime: (
    <>
      Don&apos;t show <strong>qualification questionary</strong> preview next time.
    </>
  ),
  reviewOutreachMessage: 'Review outreach messages',
  reviewOutreachMessageDescription:
    'Please review the first message and confirm it before we start the reach out process',
  robinJrBulkPersonalisingReviewBeforeSend: 'Robin Jr. is personalising each message · review before sending',
  robinJrBulkReachingOutToEachCandidate: 'Robin Jr. is reaching out to each candidate',
  checkRobinBoxForReplies: 'Check Robin-box for replies',
  checkRobinBox: 'Check Robin-box',
  confirmRemoveBulkCandidate: (name) => `Remove ${name} from the list? Rj won't reach out to them.`,
  sendingMessages: 'Sending messages...',
  bulkAllMessagesSent: 'All messages sent',
  bulkSomeMessagesCouldNotBeSent: 'Some messages could not be sent',
  sentProgress: (sent, total) => `Sent ${sent} of ${total}`,
  previewAsCandidate: 'Preview as candidate',
  regenerateMessage: 'Regenerate message',
  bulkGenerating: 'Generating...',
  bulkAllMessagesReady: 'All messages ready',
  bulkAllMessagesReadyReviewBeforeSend: 'All messages ready · review before sending',
  bulkSomeMessagesCouldNotBeGeneratedReviewBeforeSend: 'Some messages could not be generated · review before sending',
  bulkNFailed: (n) => `${n} failed`,
  bulkGenerationDoneWithFailures: (n) => `${n} messages failed · skip or retry`,
  bulkSending: 'Sending...',
  bulkSendingDoneWithFailures: (n) => `${n} failed to send`,
  bulkSendingReachingOut: (name) => `Reaching out to ${name}...`,
  bulkSendingFailure: (name) => `Failure to send message to ${name}`,
  bulkIndeedWaitingForReply: 'Waiting for Indeed reply',
  bulkIndeedSendingFailure: (name) => `Failure to send Indeed message to ${name}`,
  bulkIndeedCheckSession: 'Check your Indeed session',
  dontShowMessagePreviewNextTime: "Don't show email message preview",
  dontShowWhatsappMessagePreviewNextTime: "Don't show WhatsApp message preview next time.",
  changingTheJobWillRestart: 'When you change the job, the communication pipeline will restart',
  reactivateRobinJrTitle: 'Reactivate Robin Jr.',
  reactivateRobinJrDescription: (
    <span>
      Robin Jr. was last active at the <b>"Sent reach out"</b> stage
      <br />
      Next, it will <b>"Send first follow up"</b> based on your job settings
      <br />
      Make sure this is the right job before starting:
    </span>
  ),
  areYouSureToPauseRobinJr: 'Are you sure you want to pause Robin Jr.?',
  robinJrIsCurrentlyDescription: (currentAction) => (
    <>
      Robin Jr. is currently <strong>{currentAction}</strong>. If you pause now, you&apos;ll need to take over these
      tasks yourself. Are you sure you want to stop it?
    </>
  ),
  robinJrIndeedPauseDescription: (
    <>
      Robin Jr. is <strong>waiting for the candidate to confirm interest</strong>. If you pause, Robin Jr. won’t
      continue the communication follow-ups or schedule an interview when they reply. You’ll need to take over from
      here.
    </>
  ),
  yesStopIt: 'Yes, pause it',
  communicationEnded: 'Communication ended',
  reachingOutCandidate: 'Reaching out to candidate',
  rjCommHubIndeedWaitingForReply: 'Waiting for Indeed reply',
  rjCommHubIndeedWaitingForEmailAddress: 'Waiting for email address',
  sentFirstFollowUp: 'Sent first follow up',
  sentSecondFollowUp: 'Sent second follow up',
  robinJrActive: 'Robin jr. active',
  goodNewsCandidate: (candidateName, jobTitle, vefiedInfo) => (
    <span>
      Good news!
      <br />
      {candidateName} has shown interest in your job posting for the role of {jobTitle}.
      {vefiedInfo && (
        <>
          <br />
          Along with confirming interest, the candidate also provided additional details:
          <br />
          <br />
          {vefiedInfo}
        </>
      )}
      <br />
      <br />
      Please contact the candidate directly by <b>phone</b> or <b>email</b> to discuss next steps.
    </span>
  ),
  candidateNotInterested: (candidateName, jobTitle) => (
    <span>
      We wanted to let you know that {candidateName} is not interested in the {jobTitle} opportunity you shared.
    </span>
  ),
  didntReceiveResponse:
    "We didn't receive a response from the candidate after 2 follow-ups and 14 days. The profile has been marked as hidden to keep your pipeline clean and the follow-up has finished.",
  companyIsHiring: (params) => {
    const parts = [params.jobTitle, params.salaryRange, params.city].filter(Boolean);
    return parts.join(' | ');
  },
  loadingVacancyDetails: 'Loading vacancy details...',
  errorLoadingVacancy: (error) => `Error loading vacancy: ${error}`,
  vacancyNotFound: 'Vacancy not found',
  aboutTheRole: 'About the Role',
  yourResponsibilities: 'Your Responsibilities',
  whatWeOffer: 'What We Offer',
  certificatesLabel: 'Certificates',
  driversLicenseLabel: "Driver's License",
  interestedInOpportunity: "Interested in this opportunity? We'll put you in touch with the recruiter right away.",
  yesPlease: 'Yes, please',
  noThanks: 'No, thanks',
  questionsEmailUs: 'Questions? Email us at',
  poweredBy: 'Powered by',
  emailFooterDoNotReply:
    'Do not reply to this email. Any response you send to this email address will not reach the employer.',
  emailFooterRobinProcesses: 'Robin processes and analyses your activity in this email. AI-assisted message.',
  emailFooterUnsubscribe: 'Unsubscribe',
  emailFooterPrivacyPolicy: 'Privacy Policy',
  robinJrBrandingTitle: 'Robin junior branding',
  robinJrBrandingSubtitle: 'Customise your automated emails through Rj communication agent templates with ease',
  robinJrBrandingUploadLogo: 'Upload your logo',
  robinJrBrandingUploadHint: 'PNG, JPG or JPEG',
  robinJrBrandingUploadMaxSize: 'Max size 1MB',
  robinJrBrandingSelectColorFromScreen: 'Choose your screen color',
  robinJrBrandingSaveTemplate: 'Save the template',
  robinJrBrandingSaving: 'Saving...',
  robinJrBrandingShowPreview: 'Show Preview',
  robinJrBrandingPleaseUploadLogo: 'Please upload a logo before saving',
  robinJrBrandingInvalidFileType: 'Only PNG, JPG or JPEG files are allowed',
  robinJrBrandingFileTooLarge: 'File size must be under 1MB',
  robinJrBrandingSavedSuccessfully: 'Branding saved successfully',
  robinJrBrandingSaveFailed: 'Failed to save branding',
  robinJrBrandingOrganisation: 'Organisation',
  robinJrBrandingLoadFailed: 'Failed to load branding',
  robinJrBrandingDefaultBadge: 'Default',
  robinJrBrandingSetAsDefault: 'Set as default',
  robinJrBrandingSetAsDefaultSuccess: 'Default branding updated',
  robinJrBrandingSetAsDefaultFailed: 'Failed to update default branding',
  robinJrBrandingEyedropperNotSupported: 'Eyedropper is not supported in this browser',
  robinJrBrandingReset: 'Reset',
  robinJrBrandingResetting: 'Resetting...',
  robinJrBrandingResetConfirmTitle: 'Reset branding',
  robinJrBrandingResetConfirmDescription:
    'This will remove your custom logo and colour. The branding will revert to defaults.',
  robinJrBrandingResetSuccessfully: 'Branding reset successfully',
  robinJrBrandingResetFailed: 'Failed to reset branding',
  cantUseRobinJrUnsubscribed: (
    <span>
      You can't use Robin Jr because
      <br />
      user unsubscribed email reachout
    </span>
  ),
  clickToActivateRobinJr: 'Click to activate Robin Jr.',
  indeedNoVacancySelected: 'Please select a job to continue',
  thanksForYourInterest: 'Thanks for your interest!',
  thanksForYourResponse: 'Thanks for your response!',
  recruiterWillReachOutSoon:
    'A recruiter will reach out to you soon. While you wait for a response, would you like to receive more job openings like this?',
  byConfirmingYouAgreeToShare:
    'By confirming, you agree to share your profile with verified recruiters to be matched with relevant opportunities.',
  anyFeedbackOptional: 'Any feedback? (Optional)',
  helpUsImproveJobRecommendations: 'Help us to improve our job recommendations...',
  working_hours_per_week: 'Working hours per week',
  available_days: 'Available days',
  travel_time: 'Travel time',
  transportation: 'Transportation',
  reachedOutQuestion: 'Reached Out?',
  reachedOutQuestionDescription:
    "Tell us, and we'll update the status so you know exactly who you've already contacted",
  noNotYet: 'No, not yet',
  yesMarkAsContacted: 'Yes, mark as contacted',
  detachJob: 'Detach job',

  candidateIsMovedTo: (candidateName, status) => `${candidateName} is moved to ${status}`,
  weUnderstandThanks: 'We understand, thanks!',
  noMoreJobAlertsFromUs: "You won't get any more job alerts from us. We appreciate your feedback.",
  recruiterWillReachOutSoonConfirmation: 'A recruiter will reach out to you soon.',
  viewVacancy: 'View vacancy',
  noVacancyAnymore: 'No vacancy anymore',
  toChangeYourEmailPleaseEnterYourPassword: 'To change your email, please enter your password',
  rjCommHubWhatsAppMessage: ({
    candidateFirstName,
    recruiterFirstName,
    companyName,
    jobBoardName,
    vacancyName,
    vacancyLocation,
    vacancySalary,
    vacancyShift,
    includeEmailNote,
  }) => {
    const jobDetails = [vacancyName, vacancyLocation, vacancySalary, vacancyShift].filter(Boolean);

    return (
      <span>
        Hi {candidateFirstName},
        <br />
        <br />
        {recruiterFirstName} from {companyName} saw your CV on {jobBoardName} and would like to speak with you about
        this job:
        <br />
        <br />
        {jobDetails.map((line) => (
          <>
            {line}
            <br />
          </>
        ))}
        {includeEmailNote ? (
          <>
            <br />
            I&apos;ve also sent this job to you by email.
          </>
        ) : (
          <>
            <br />
            Want to know more? Click below to view this job.
          </>
        )}
      </span>
    );
  },
  rjCommHubWhatsAppMessageString: ({
    candidateFirstName,
    recruiterFirstName,
    companyName,
    jobBoardName,
    vacancyName,
    vacancyLocation,
    vacancySalary,
    vacancyShift,
    includeEmailNote,
  }) => {
    const jobDetails = [vacancyName, vacancyLocation, vacancySalary, vacancyShift].filter(Boolean).join('\n');
    const message = `Hi ${candidateFirstName},\n\n${recruiterFirstName} from ${companyName} saw your CV on ${jobBoardName} and would like to speak with you about this job:\n\n${jobDetails}`;

    return includeEmailNote
      ? `${message}\n\nI've also sent this job to you by email.`
      : `${message}\n\nWant to know more? Click below to view this job.`;
  },

  checked: 'Checked',
  checkedCandidateInfoAt: (lastVerifiedAt: string) => (
    <>
      Candidate info is confirmed by candidate
      <br />
      {lastVerifiedAt}
    </>
  ),
  checkedPreferencesAt: (lastVerifiedAt: string) => (
    <>
      Job preferences confirmed by candidate
      <br />
      {lastVerifiedAt}
    </>
  ),
  checkedAvailabilityAt: (lastVerifiedAt: string) => (
    <>
      Available for work
      <br />
      confirmed {lastVerifiedAt}
    </>
  ),
  hideCandidateFeedbackTitle: 'Help us improve your matches',
  hideCandidateFeedbackDescription:
    "Could you share why you're hiding this candidate? Your feedback makes our matching system smarter.",
  hideCandidateFeedbackReasonIrrelevantExperience: 'Irrelevant work experience or skills',
  hideCandidateFeedbackReasonMismatchedPreferences: 'Mismatched career preferences',
  hideCandidateFeedbackReasonLocation: 'Unsuitable location or commute',
  hideCandidateFeedbackReasonQualifications: 'Insufficient qualifications (licenses, certifications, languages)',
  hideCandidateFeedbackReasonLowQuality: 'Low-quality or outdated profile/resume',
  hideCandidateFeedbackDetailsPlaceholder: 'Add more details (optional)',

  /* ---- start: added by AI ---- */

  // Questionnaire Screen
  weNeedABitMoreInfo: 'We need a bit more info',
  someDetailsAreMissing: (jobBoard: string) => (
    <>
      Some details are missing from your <strong>{jobBoard}</strong> profile. Adding them will help recruiters see your
      full profile and speed up the hiring process.
    </>
  ),
  addingThemWillHelp: 'Adding them will help recruiters see your full profile and speed up the hiring process.',
  areYouCurrentlyOpenToWork: 'Are you currently open to work?',
  doYouHaveFollowingCertificates: 'Do you have these certificates and/or driving licenses? ',
  doYouHaveAnyOtherCertificates: 'Do you have any other certificates and/or driving licenses?',
  isThisIncomeAcceptableForYou: 'Is this income acceptable for you?',
  whatIsYourDesiredSalaryRange: 'What is your desired salary range?',
  thisJobOffersASalary: (amount: string, unit: string) =>
    `This job offers a salary of €${amount}${unit ? ` per ${unit}` : ''}`,
  areYouAvailableForThisSchedule: 'Are you available for this schedule?',
  doYouHaveAnyOtherShiftAvailable: 'Do you have any other shifts available?',
  whatAreYouAvailableDays: 'What are your available days?',
  areYouComfortableWithTheseRequirements: 'Are you comfortable with these requirements?',
  areYouAbleToPerformTheseSpecificJobTasks: 'Can you do these tasks?',
  pleaseTellUsAboutAnyLimitationsOrPreferences: 'Please tell us about any limitations or preferences',
  areThereAnyOtherTasksYouCanDo: 'Are there any other tasks you can do?',
  requiresWorkingHours: (hours: string, unit: string) => `Requires working ${hours} hours per ${unit}`,
  howManyHoursPerWeekWouldYouLikeToWork: (unit: string) => `Do these hours per ${unit} work for you?`,
  doTheseHoursPerWeekWorkForYou: 'Do these hours per week work for you?',
  doYouSpeakTheseLanguages: 'Do you speak these languages?',
  whichLanguagesDoYouSpeak: 'Which languages do you speak?',
  submitAndUpdateInfo: 'Submit and update info',
  byConfirming:
    'By confirming, you agree to share your profile with verified recruiters to be matched with relevant opportunities.',
  typeAndPressEnterToAdd: 'Type and press Enter to add...',
  to: 'to',
  couldNotGenerateEnrichedVacancy: 'Could not generate enriched vacancy',
  couldNotGenerateJobPreview: 'Could not generate job preview',
  previewInIndeed: 'Preview in Indeed',
  previewInIndeedModalTitle: 'This is how your job will appear in Indeed',
  previewInIndeedModalDescription:
    'Some formatting (like bold text, bullet points, or colors) isn’t supported on Indeed and gets removed. What you see here is the plain-text version candidates will see',
  backToJobPreview: 'Back to job preview',
  backToEditor: 'Back to editor',

  addMore: 'Add more',
  daily: 'daily',
  week: 'week',
  day: 'day',
  hour: 'hour',
  workShiftAvailability: 'Work shift availability',
  certificationsLicenses: 'Certifications / licenses',
  languagesSpoken: 'Languages spoken',
  yourProfileHasBeenUpdated: 'Your profile has been updated!',
  yourInformationIsNowComplete:
    'Your information is now complete and has been shared with the recruiter. This will help speed up the hiring process.',
  questionnaireCompleteTitle: "You're all set",
  questionnaireCompleteMessage:
    'You answered all questions. Your profile is complete and ready to review. The recruiter will contact you soon.',
  jobAlertsActivated: 'Job alerts activated!',
  wellKeepYouUpdatedWithMoreJobOpportunities:
    "We'll keep you updated with more job opportunities that match your interests. Thanks for staying connected!",
  jobNotificationsEnabledTitle: "You're all set!",
  jobNotificationsEnabledDescription:
    'Robin will let you know as soon as a new job matches your profile. No inbox spam, promise.',
  youllHearFromUs: "You'll hear from us",
  wellReachOutWhenAJobMatchesYourProfile: "We'll reach out when a job matches your profile.",
  confirmUnsubscribeTitle: 'Confirm unsubscribe',
  confirmUnsubscribeDescription: "You won't receive any more job alerts from us. You can always subscribe again later.",
  confirmUnsubscribe: 'Confirm unsubscribe',
  confirmUnsubscribeFooterText:
    'By confirming, you are opting not to share your profile with verified recruiters, and you will not be matched with relevant opportunities.',
  updateYourProfile: 'Update your profile',
  keepYourInformationUpToDate: 'Keep your information up to date on Robin to get better job matches.',
  saveProfile: 'Save profile',
  interviewWithRecruiterFromCompany: (recruiterFirstName: string, companyName: string) =>
    `Interview with ${recruiterFirstName} from ${companyName}`,

  messagesPulledSuccessfully: 'Messages pulled successfully!',
  messagesPulledFailed: 'Oops! Messages weren’t pulled.',
  messagesSynced: 'Messages Synced',
  messagesNotSynced: 'Not Synced',
  lastJobboardMessage: (jobboard: string) => `Last ${jobboard} message`,
  clickResyncToTryAgainOrReachOutToSupport: 'Click "Resync" to retry, or reach out to support if the issue continues.',
  lastSynced: 'Last synced',
  resync: 'Resync',
  noMessagesFound: 'No messages found',
  statusesDropdownLabel: 'Automatically assign status (candidates who reply will appear in your ATS with this status).',
  refreshStatuses: 'Refresh statuses',
  youAreNotAllowedToRefreshStatusesToday: 'You are allowed to refresh statuses once per day.',
  whoAreYouHiringToday: 'Who are you hiring today?',
  jobPreviewIsAvailable: 'Job preview is now available!',

  viewFullJobDetails: 'View full job details',
  noCandidatesFound: 'No candidates found',
  keyResponsabilities: 'Key responsabilities',
  salaryRange: 'Salary range',
  languageLevel: 'Language level',
  chooseAFileOrDragAndDrop: 'Choose a file or drag and drop',
  uploadFileToGetStarted: 'Upload a PDF or Word document to get started',
  creatingChatFrom: (source) => `Creating chat from ${source}...`,
  matchRate: 'Match rate',
  whoIsRobinJr: 'Who is Robin Jr?',
  howCanIConnectMyAts: 'How can I connect my ATS?',
  canIUploadAFile: 'Can I upload a file?',
  messageSentTo: (name: string) => `Message sent to ${name}`,
  searchOrCreateLabel: 'Search or create label',
  selectCallOutcome: 'Select call outcome',
  copiedToClipboard: 'Copied to clipboard',
  emailNotAvaialbe: 'Email not available',
  enterCandidateEmail: 'Enter candidate email',
  scheduleInterviewNow: 'Schedule an interview now',
  pleaseGrantAccessToYourCalendar: 'Please grant access to your calendar to use interview scheduler',
  pleaseConnectYourEmailToUseInterviewScheduler: 'Please connect your email to use interview scheduler',
  schedulerInviteSubject: 'Interview Invitation – Schedule Your Meeting',
  schedulerInviteMessage: `<span>Hi {firstName},</span><br/><br/><span>We’d like to set up an interview with you. Please click the link below and pick a time that works best for you:</span><br/><br/><span>{schedulerLink}</span><br/><br/><span>If you can't find a good time or need help, just reply to this email.</span><br/><br/><span>Thanks,</span><br/><br/><span>{recruiterFullName}</span>`,
  schedulerLinkText: 'Schedule Interview',
  theFollowingFieldsAreRequired: 'The following fields are required:',
  currentStatus: 'Current status:',
  whatTypeOfInterviewWouldYouLikeToSchedule: 'What type of interview would you like to schedule?',
  setupInterview: 'Setup interview',
  dontShowSetupInterviewAgain: "Don't show setup interview again",
  youCanManageEmailSettings: (
    <span>
      You can manage these interview event options in your{' '}
      <a href="/email-settings" target="_blank" rel="noopener noreferrer" className="default-link">
        email settings
      </a>
    </span>
  ),
  typeToSearchForAnAddress: 'Type to search for an address',
  matchInsights: 'Match insights',
  checkedPreferences: 'Checked preferences',
  seeMatchedCandidates: 'See matched candidates',
  searchButtonIsReady:
    'Your job preview and search are ready. Review and improve the description before saving, as candidates will base their decision on it',
  /* ---- end: added by AI ---- */

  discardChangesModalTitle: 'Discard changes?',
  discardChangesModalDescription: 'You have unsaved changes. Are you sure you want to discard them?',
  keepEditing: 'Keep editing',
  discardChanges: 'Discard changes',
  jobTitleAndStatus: (jobTitle: string, status: string) => `${jobTitle} ${status ? `and ${status}` : ''}`,
  writeWithAi: 'Write with AI',
  writingCustomizedMessage: 'We are writing a customized message, based on the CV and your vacancy.',
  nylasCalendarConnectionModalTitle: 'Let qualified candidates book instantly',
  nylasCalendarConnectionModalDescription: (
    <>
      Set up your calendar so candidates can schedule a call right after qualifying.
      <br />
      That way, you won't miss a match.
    </>
  ),
  nylasCalendarConnectionModalConnectCalendar: 'Connect your calendar in Email settings to get started',
  nylasCalendarConnectionModalCalendarSetUpTitle: 'Your calendar is set up',
  nylasCalendarConnectionModalCalendarSetUpText: 'Candidates can now book a call with you.',
  nylasCalendarStatusValid: 'Connected',
  nylasCalendarStatusInvalid: 'Invalid',
  nylasCalendarStatusNotConnected: 'Not connected',
  nylasCalendarStatusError: 'Error',
  nylasCalendarStatusUnknown: 'Unknown',
  goToEmailSettings: 'Set up calendar',
  maybeLater: 'Maybe later',
  videoInterviewAboutTheVacancy: 'Video interview about the vacancy',
  introductionAtTheLocation: 'Introduction at the location',
  telephoneConversationAboutTheVacancy: 'Telephone conversation about the vacancy',
  onlineInterview: 'Online interview',
  inPersonInterview: 'In-person interview',
  callInterview: 'Call interview',
  role: 'Role',
  weFoundSomeGreatMatchesForYou: 'We found some great matches for you!',
  failedToLoadJobRecommendations: 'Failed to load job recommendations.',
  interviewFeedbackTitle: 'Tell us a bit more',
  interviewFeedbackSubtitleFallback: 'About your recent interview.',
  interviewFeedbackSubtitleCandidateFull: (name, jobTitle) =>
    `About your interview with ${name} for the ${jobTitle} job.`,
  interviewFeedbackSubtitleCandidateName: (name) => `About your interview with ${name}.`,
  interviewFeedbackSubtitleRecruiterFull: (name, jobTitle) =>
    `About your interview with ${name} for the ${jobTitle} role.`,
  interviewFeedbackSubtitleRecruiterName: (name) => `About your interview with ${name}.`,
  interviewFeedbackTagsLabelHigh: 'What stood out?',
  interviewFeedbackTagsLabelLow: 'What could have been better?',
  interviewFeedbackCommentLabelHigh: 'Anything else? (optional)',
  interviewFeedbackCommentLabelLow: 'Tell us more (optional)',
  interviewFeedbackCommentPlaceholder: 'Write your feedback here',
  interviewFeedbackSubmit: 'Submit feedback',
  interviewFeedbackThankYouTitle: 'Thanks for the feedback',
  interviewFeedbackThankYouHigh: "Glad it went well. We'll keep working to make your next match even better.",
  interviewFeedbackThankYouLowTitle: 'Thanks for being honest',
  interviewFeedbackThankYouLow:
    "We're sorry it wasn't better. The team will look into this and make it better next time.",
  interviewFeedbackReviewTitle: 'Thanks for the feedback',
  interviewFeedbackReviewBody:
    'Glad it went well. Would you mind sharing that on Google? It helps other people find us.',
  interviewFeedbackReviewButton: 'Leave a Google review',
  interviewFeedbackInvalidTitle: "This link isn't valid",
  interviewFeedbackInvalidBody:
    'It may have expired or already been used. If you still want to share feedback, reply to the message from Robin.',
  interviewFeedbackTagCommunication: 'Communication',
  interviewFeedbackTagScheduling: 'Scheduling',
  interviewFeedbackTagClarity: 'Clarity of info',
  interviewFeedbackTagSpeed: 'Speed',
  interviewFeedbackTagInterviewer: 'The interviewer',
  interviewFeedbackTagOverall: 'Overall process',
  viewFullJob: 'View full job',
  applyNow: 'Apply now',
  notifyMeAboutNewJobs: 'Notify me about new jobs',
  imNotLookingRightNow: "I'm not looking right now",
  youreSetUpForNewMatchAlerts: "You're set up for new match alerts. We'll send another in a few days.",
  stopAlerts: 'Stop alerts',
  percentMatch: (percent) => `${percent}% Match`,
  noJobRecommendationsTitle: 'No matches right now',
  noJobRecommendationsMessage: "We'll notify you as soon as we find a great match for your profile.",
  hereAreJobsThatFitYourProfile: (count) =>
    `Here ${count === 1 ? 'is' : 'are'} ${count} ${count === 1 ? 'job' : 'jobs'} that fit your profile`,
  robinUsesYourActivityOnThisPageForBetterMatches:
    'Robin uses your activity on this page to find better matches for you',
  rejectCandidateModalTitle: 'Why is this candidate not the right match?',
  rejectCandidateModalDescription: "Tell us what didn't fit. Robin uses this to send better matches next time.",
  rejectCandidateReasonNotEnoughExperience: 'Not enough experience',
  rejectCandidateReasonMissingCertificate: 'Missing required certificate',
  rejectCandidateReasonNotAvailableForHours: 'Not available for required hours',
  rejectCandidateReasonLivesTooFar: 'Lives too far from job location',
  rejectCandidateReasonPositionFilled: 'Position already filled',
  rejectCandidateReasonOther: 'Other',
  rejectCandidateCustomReasonPlaceholder: 'Help candidate to improve for future job ...',
  rejectCandidateSubmit: 'Send your feedback',
  rejectCandidate: 'Reject candidate',
  sendInterviewInvite: 'Send interview invite',
  rejected: 'Rejected',
  candidateRejectedSuccessfully: 'Candidate hidden successfully',
  candidateAppliedRecommendation: 'Applied',
  whyYouAreTheRightFit: 'Why you are the right fit for this job',
  interestedInThisOpportunity: "Interested in this opportunity? We'll put you in touch with the recruiter right away.",
  backToJobList: 'Back to job list',
  pauseJobRecommendationsTitle: 'Totally understood',
  pauseJobRecommendationsDescription:
    "We'll pause everything on our end. Your info will be removed from Robin's reach-out list. You won't hear from us until you choose to come back.",
  pauseJobRecommendationsConfirm: 'Sounds good',
  pauseJobRecommendationsKeepShowing: 'Actually, keep showing me jobs',
};
